import { jsx, jsxs, Fragment as Fragment$1 } from 'react/jsx-runtime';
import { createContext, useState, useCallback, useEffect, useContext, Fragment, useRef, useMemo, useReducer, cloneElement, Children, forwardRef } from 'react';
import { useIsomorphicLayoutEffect, Tooltip, Alert, CodeBlock, Accordion, AccordionItem, AccordionToggle, AccordionContent, Popover, PopoverPosition, Button, Icon, Flex, FlexItem, Card, CardHeader, CardTitle, CardBody, Stack, Label, CardFooter, Gallery, ToolbarItem, SearchInput, Select, SelectList, SelectOption, MenuToggle, Badge, Toolbar, ToolbarContent, EmptyState, EmptyStateBody, EmptyStateFooter, EmptyStateActions, PageSection, Content, Title, Divider, WizardNavItem, ExpandableSection, List, ListItem, Radio, ActionList, ActionListGroup, ActionListItem, DrawerPanelContent, DrawerHead, DrawerActions, DrawerCloseButton, DrawerPanelBody, Drawer, DrawerContent, DrawerContentBody, StackItem } from '@patternfly/react-core';
import SearchIcon from '@patternfly/react-icons/dist/js/icons/search-icon';
import { css } from '@patternfly/react-styles';
import RocketIcon from '@patternfly/react-icons/dist/js/icons/rocket-icon';
import { __rest, __awaiter } from 'tslib';
import { Modal as Modal$1, ModalVariant } from '@patternfly/react-core/deprecated';
import * as ReactDOM from 'react-dom';
import { createPortal } from 'react-dom';
import { renderToStaticMarkup } from 'react-dom/server';
import CopyIcon from '@patternfly/react-icons/dist/js/icons/copy-icon';
import LightbulbIcon from '@patternfly/react-icons/dist/js/icons/lightbulb-icon';
import FireIcon from '@patternfly/react-icons/dist/js/icons/fire-icon';
import { marked } from 'marked';
import SyncAltIcon from '@patternfly/react-icons/dist/js/icons/sync-alt-icon';
import CheckCircleIcon from '@patternfly/react-icons/dist/js/icons/check-circle-icon';
import '@patternfly/react-icons/dist/js/icons/exclamation-circle-icon';
import InfoCircleIcon from '@patternfly/react-icons/dist/js/icons/info-circle-icon';
import ExternalLinkAltIcon from '@patternfly/react-icons/dist/js/icons/external-link-alt-icon';
import OutlinedBookmarkIcon from '@patternfly/react-icons/dist/js/icons/outlined-bookmark-icon';
import OutlinedClockIcon from '@patternfly/react-icons/dist/js/icons/outlined-clock-icon';
import ArrowRightIcon from '@patternfly/react-icons/dist/js/icons/arrow-right-icon';
import BarsIcon from '@patternfly/react-icons/dist/js/icons/bars-icon';

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

var m,x=m||(m={});x.Pop="POP";x.Push="PUSH";x.Replace="REPLACE";var y="production"!==process.env.NODE_ENV?function(a){return Object.freeze(a)}:function(a){return a};function z(a,b){if(!a){"undefined"!==typeof console&&console.warn(b);try{throw Error(b);}catch(g){}}}function A(a){a.preventDefault();a.returnValue="";}
function B(){var a=[];return {get length(){return a.length},push:function(b){a.push(b);return function(){a=a.filter(function(a){return a!==b});}},call:function(b){a.forEach(function(a){return a&&a(b)});}}}function D(){return Math.random().toString(36).substr(2,8)}function E(a){var b=a.pathname,g=a.search;a=a.hash;return (void 0===b?"/":b)+(void 0===g?"":g)+(void 0===a?"":a)}
function F(a){var b={};if(a){var g=a.indexOf("#");0<=g&&(b.hash=a.substr(g),a=a.substr(0,g));g=a.indexOf("?");0<=g&&(b.search=a.substr(g),a=a.substr(0,g));a&&(b.pathname=a);}return b}
function createBrowserHistory(a){function b(){var a=h.location,d=f.state||{};return [d.idx,y({pathname:a.pathname,search:a.search,hash:a.hash,state:d.usr||null,key:d.key||"default"})]}function g(a){return "string"===typeof a?a:E(a)}function t(a,d){void 0===d&&(d=null);return y(_extends({},l,{},"string"===typeof a?F(a):a,{state:d,key:D()}))}function v(a){n=a;a=b();q=a[0];l=a[1];c.call({action:n,location:l});}function w(a,d){function c(){w(a,d);}var k=m.Push,C=t(a,d);if(!e.length||(e.call({action:k,
location:C,retry:c}),!1)){var b=[{usr:C.state,key:C.key,idx:q+1},g(C)];C=b[0];b=b[1];try{f.pushState(C,"",b);}catch(G){h.location.assign(b);}v(k);}}function u(a,d){function c(){u(a,d);}var b=m.Replace,k=t(a,d);e.length&&(e.call({action:b,location:k,retry:c}),1)||(k=[{usr:k.state,key:k.key,idx:q},g(k)],f.replaceState(k[0],"",k[1]),v(b));}function r(a){f.go(a);}void 0===a&&(a={});a=a.window;var h=void 0===a?document.defaultView:a,f=h.history,p=null;h.addEventListener("popstate",function(){if(p)e.call(p),
p=null;else {var a=m.Pop,d=b(),c=d[0];d=d[1];if(e.length)if(null!=c){var f=q-c;f&&(p={action:a,location:d,retry:function(){r(-1*f);}},r(f));}else "production"!==process.env.NODE_ENV?z(!1,"You are trying to block a POP navigation to a location that was not created by the history library. The block will fail silently in production, but in general you should do all navigation with the history library (instead of using window.history.pushState directly) to avoid this situation."):void 0;else v(a);}});var n=
m.Pop;a=b();var q=a[0],l=a[1],c=B(),e=B();null==q&&(q=0,f.replaceState(_extends({},f.state,{idx:q}),""));return {get action(){return n},get location(){return l},createHref:g,push:w,replace:u,go:r,back:function(){r(-1);},forward:function(){r(1);},listen:function(a){return c.push(a)},block:function(a){var d=e.push(a);1===e.length&&h.addEventListener("beforeunload",A);return function(){d();e.length||h.removeEventListener("beforeunload",A);}}}}function createMemoryHistory(a){function b(a,b){void 0===b&&(b=null);return y(_extends({},n,{},"string"===typeof a?F(a):a,{state:b,key:D()}))}function g(a,b,f){return !l.length||(l.call({action:a,location:b,retry:f}),!1)}function t(a,b){p=a;n=b;q.call({action:p,location:n});}function v(a,e){var c=m.Push,d=b(a,e);"production"!==process.env.NODE_ENV?z("/"===n.pathname.charAt(0),"Relative pathnames are not supported in memory history.push("+JSON.stringify(a)+")"):void 0;g(c,d,function(){v(a,e);})&&
(f+=1,h.splice(f,h.length,d),t(c,d));}function w(a,e){var c=m.Replace,d=b(a,e);"production"!==process.env.NODE_ENV?z("/"===n.pathname.charAt(0),"Relative pathnames are not supported in memory history.replace("+JSON.stringify(a)+")"):void 0;g(c,d,function(){w(a,e);})&&(h[f]=d,t(c,d));}function u(a){var b=Math.min(Math.max(f+a,0),h.length-1),c=m.Pop,d=h[b];g(c,d,function(){u(a);})&&(f=b,t(c,d));}void 0===a&&(a={});var r=a;a=r.initialEntries;r=r.initialIndex;var h=(void 0===a?["/"]:a).map(function(a){var b=
y(_extends({pathname:"/",search:"",hash:"",state:null,key:D()},"string"===typeof a?F(a):a));"production"!==process.env.NODE_ENV?z("/"===b.pathname.charAt(0),"Relative pathnames are not supported in createMemoryHistory({ initialEntries }) (invalid entry: "+JSON.stringify(a)+")"):void 0;return b}),f=Math.min(Math.max(null==r?h.length-1:r,0),h.length-1),p=m.Pop,n=h[f],q=B(),l=B();return {get index(){return f},get action(){return p},get location(){return n},createHref:function(a){return "string"===typeof a?
a:E(a)},push:v,replace:w,go:u,back:function(){u(-1);},forward:function(){u(1);},listen:function(a){return q.push(a)},block:function(a){return l.push(a)}}}

var QuickStartStatus;
(function (QuickStartStatus) {
    QuickStartStatus["COMPLETE"] = "Complete";
    QuickStartStatus["IN_PROGRESS"] = "In Progress";
    QuickStartStatus["NOT_STARTED"] = "Not started";
})(QuickStartStatus || (QuickStartStatus = {}));
var QuickStartTaskStatus;
(function (QuickStartTaskStatus) {
    QuickStartTaskStatus["INIT"] = "Initial";
    QuickStartTaskStatus["VISITED"] = "Visited";
    QuickStartTaskStatus["REVIEW"] = "Review";
    QuickStartTaskStatus["SUCCESS"] = "Success";
    QuickStartTaskStatus["FAILED"] = "Failed";
})(QuickStartTaskStatus || (QuickStartTaskStatus = {}));

const QUICKSTART_SEARCH_FILTER_KEY = 'keyword';
const QUICKSTART_STATUS_FILTER_KEY = 'status';
const QUICKSTART_ID_FILTER_KEY = 'quickstart';
const QUICKSTART_TASKS_INITIAL_STATES = [
    QuickStartTaskStatus.INIT,
    QuickStartTaskStatus.VISITED,
];
const HELP_TOPIC_NAME_KEY = 'topic';

let createHistory;
try {
    if (process.env.NODE_ENV === 'test') {
        // Running in node. Can't use browser history
        createHistory = createMemoryHistory;
    }
    else {
        createHistory = createBrowserHistory;
    }
}
catch (unused) {
    createHistory = createBrowserHistory;
}
const history = createHistory();
const removeQueryArgument = (k) => {
    const params = new URLSearchParams(window.location.search);
    if (params.has(k)) {
        params.delete(k);
        const url = new URL(window.location.href);
        history.replace(`${url.pathname}?${params.toString()}${url.hash}`);
    }
};
const setQueryArgument = (k, v) => {
    if (!v) {
        return removeQueryArgument(k);
    }
    const params = new URLSearchParams(window.location.search);
    if (params.get(k) !== v) {
        params.set(k, v);
        const url = new URL(window.location.href);
        history.replace(`${url.pathname}?${params.toString()}${url.hash}`);
    }
};
const clearFilterParams = () => {
    removeQueryArgument(QUICKSTART_SEARCH_FILTER_KEY);
    removeQueryArgument(QUICKSTART_STATUS_FILTER_KEY);
};

var Status$1 = "Status";
var Prerequisites = "Prerequisites";
var Complete = "Complete";
var Start = "Start";
var Continue = "Continue";
var Next = "Next";
var Close = "Close";
var Back = "Back";
var Restart = "Restart";
var Yes = "Yes";
var No = "No";
var Cancel = "Cancel";
var Leave = "Leave";
var Type = "Quick start";
var en = {
	"No results found": "No results found",
	"No results match the filter criteria. Remove filters or clear all filters to show results.": "No results match the filter criteria. Remove filters or clear all filters to show results.",
	"Clear all filters": "Clear all filters",
	"Quick Starts": "Quick Starts",
	"Complete ({{statusCount, number}})": "Complete ({{statusCount, number}})",
	"In progress ({{statusCount, number}})": "In progress ({{statusCount, number}})",
	"Not started ({{statusCount, number}})": "Not started ({{statusCount, number}})",
	"Filter by keyword...": "Filter by keyword...",
	"Select filter": "Select filter",
	Status: Status$1,
	"{{count, number}} item": "{{count, number}} item",
	"{{count, number}} item_plural": "{{count, number}} items",
	"Prerequisites ({{totalPrereqs}})": "Prerequisites ({{totalPrereqs}})",
	"View Prerequisites ({{totalPrereqs}})": "View Prerequisites ({{totalPrereqs}})",
	Prerequisites: Prerequisites,
	"Show prerequisites": "Show prerequisites",
	Complete: Complete,
	"In progress": "In progress",
	"Not started": "Not started",
	"{{duration, number}} minutes": "{{duration, number}} minutes",
	"One or more verifications did not pass during this quick start. Revisit the tasks or the help links, and then try again.": "One or more verifications did not pass during this quick start. Revisit the tasks or the help links, and then try again.",
	"Start {{nextQSDisplayName}} quick start": "Start {{nextQSDisplayName}} quick start",
	Start: Start,
	Continue: Continue,
	Next: Next,
	Close: Close,
	Back: Back,
	Restart: Restart,
	"In this quick start, you will complete {{count, number}} task": "In this quick start, you will complete {{count, number}} task",
	"In this quick start, you will complete {{count, number}} task_plural": "In this quick start, you will complete {{count, number}} tasks",
	"{{taskIndex, number}}": "{{taskIndex, number}}",
	"Check your work": "Check your work",
	Yes: Yes,
	No: No,
	"{{index, number}} of {{tasks, number}}": "{{index, number}} of {{tasks, number}}",
	"Leave quick start?": "Leave quick start?",
	Cancel: Cancel,
	Leave: Leave,
	"Your progress will be saved.": "Your progress will be saved.",
	"Not available": "Not available",
	"Copy to clipboard": "Copy to clipboard",
	"Successfully copied to clipboard!": "Successfully copied to clipboard!",
	Type: Type,
	"{{type}} • {{duration, number}} minutes": "{{type}} • {{duration, number}} minutes"
};

/* eslint-disable */
// https://github.com/i18next/i18next/blob/master/src/PluralResolver.js
const sets = [
    {
        lngs: [
            'ach',
            'ak',
            'am',
            'arn',
            'br',
            'fil',
            'gun',
            'ln',
            'mfe',
            'mg',
            'mi',
            'oc',
            'pt',
            'pt-BR',
            'tg',
            'tl',
            'ti',
            'tr',
            'uz',
            'wa',
        ],
        nr: [1, 2],
        fc: 1,
    },
    {
        lngs: [
            'af',
            'an',
            'ast',
            'az',
            'bg',
            'bn',
            'ca',
            'da',
            'de',
            'dev',
            'el',
            'en',
            'eo',
            'es',
            'et',
            'eu',
            'fi',
            'fo',
            'fur',
            'fy',
            'gl',
            'gu',
            'ha',
            'hi',
            'hu',
            'hy',
            'ia',
            'it',
            'kk',
            'kn',
            'ku',
            'lb',
            'mai',
            'ml',
            'mn',
            'mr',
            'nah',
            'nap',
            'nb',
            'ne',
            'nl',
            'nn',
            'no',
            'nso',
            'pa',
            'pap',
            'pms',
            'ps',
            'pt-PT',
            'rm',
            'sco',
            'se',
            'si',
            'so',
            'son',
            'sq',
            'sv',
            'sw',
            'ta',
            'te',
            'tk',
            'ur',
            'yo',
        ],
        nr: [1, 2],
        fc: 2,
    },
    {
        lngs: [
            'ay',
            'bo',
            'cgg',
            'fa',
            'ht',
            'id',
            'ja',
            'jbo',
            'ka',
            'km',
            'ko',
            'ky',
            'lo',
            'ms',
            'sah',
            'su',
            'th',
            'tt',
            'ug',
            'vi',
            'wo',
            'zh',
        ],
        nr: [1],
        fc: 3,
    },
    { lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'], nr: [1, 2, 5], fc: 4 },
    { lngs: ['ar'], nr: [0, 1, 2, 3, 11, 100], fc: 5 },
    { lngs: ['cs', 'sk'], nr: [1, 2, 5], fc: 6 },
    { lngs: ['csb', 'pl'], nr: [1, 2, 5], fc: 7 },
    { lngs: ['cy'], nr: [1, 2, 3, 8], fc: 8 },
    { lngs: ['fr'], nr: [1, 2], fc: 9 },
    { lngs: ['ga'], nr: [1, 2, 3, 7, 11], fc: 10 },
    { lngs: ['gd'], nr: [1, 2, 3, 20], fc: 11 },
    { lngs: ['is'], nr: [1, 2], fc: 12 },
    { lngs: ['jv'], nr: [0, 1], fc: 13 },
    { lngs: ['kw'], nr: [1, 2, 3, 4], fc: 14 },
    { lngs: ['lt'], nr: [1, 2, 10], fc: 15 },
    { lngs: ['lv'], nr: [1, 2, 0], fc: 16 },
    { lngs: ['mk'], nr: [1, 2], fc: 17 },
    { lngs: ['mnk'], nr: [0, 1, 2], fc: 18 },
    { lngs: ['mt'], nr: [1, 2, 11, 20], fc: 19 },
    { lngs: ['or'], nr: [2, 1], fc: 2 },
    { lngs: ['ro'], nr: [1, 2, 20], fc: 20 },
    { lngs: ['sl'], nr: [5, 1, 2, 3], fc: 21 },
    { lngs: ['he', 'iw'], nr: [1, 2, 20, 21], fc: 22 },
];
const _rulesPluralsTypes = {
    1: function (n) {
        return Number(n > 1);
    },
    2: function (n) {
        return Number(n != 1);
    },
    3: function (n) {
        return 0;
    },
    4: function (n) {
        return Number(n % 10 == 1 && n % 100 != 11
            ? 0
            : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)
                ? 1
                : 2);
    },
    5: function (n) {
        return Number(n == 0
            ? 0
            : n == 1
                ? 1
                : n == 2
                    ? 2
                    : n % 100 >= 3 && n % 100 <= 10
                        ? 3
                        : n % 100 >= 11
                            ? 4
                            : 5);
    },
    6: function (n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function (n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function (n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function (n) {
        return Number(n >= 2);
    },
    10: function (n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function (n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function (n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function (n) {
        return Number(n !== 0);
    },
    14: function (n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function (n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function (n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function (n) {
        return Number(n == 1 || (n % 10 == 1 && n % 100 != 11) ? 0 : 1);
    },
    18: function (n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function (n) {
        return Number(n == 1
            ? 0
            : n == 0 || (n % 100 > 1 && n % 100 < 11)
                ? 1
                : n % 100 > 10 && n % 100 < 20
                    ? 2
                    : 3);
    },
    20: function (n) {
        return Number(n == 1 ? 0 : n == 0 || (n % 100 > 0 && n % 100 < 20) ? 1 : 2);
    },
    21: function (n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function (n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    },
};
function createRules() {
    const rules = {};
    sets.forEach((set) => {
        set.lngs.forEach((l) => {
            rules[l] = {
                numbers: set.nr,
                plurals: _rulesPluralsTypes[set.fc],
            };
        });
    });
    return rules;
}
class PluralResolver {
    constructor(options = {}) {
        this.options = options;
        this.rules = createRules();
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    getRule(code) {
        return this.rules[code];
    }
    needsPlural(code) {
        const rule = this.getRule(code);
        return rule && rule.numbers.length > 1;
    }
    getPluralFormsOfKey(code, key) {
        return this.getSuffixes(code).map((suffix) => key + suffix);
    }
    getSuffixes(code) {
        const rule = this.getRule(code);
        if (!rule) {
            return [];
        }
        return rule.numbers.map((number) => this.getSuffix(code, number));
    }
    getSuffix(code, count) {
        const rule = this.getRule(code);
        if (rule) {
            // if (rule.numbers.length === 1) return ''; // only singular
            const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
            let suffix = rule.numbers[idx];
            // special treatment for lngs only having singular and plural
            if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
                if (suffix === 2) {
                    suffix = 'plural';
                }
                else if (suffix === 1) {
                    suffix = '';
                }
            }
            const returnSuffix = () => this.options.prepend && suffix.toString()
                ? this.options.prepend + suffix.toString()
                : suffix.toString();
            // COMPATIBILITY JSON
            // v1
            if (this.options.compatibilityJSON === 'v1') {
                if (suffix === 1) {
                    return '';
                }
                if (typeof suffix === 'number') {
                    return `_plural_${suffix.toString()}`;
                }
                return returnSuffix();
            }
            if ( /* v2 */this.options.compatibilityJSON === 'v2') {
                return returnSuffix();
            }
            if (
            /* v3 - gettext index */ this.options.simplifyPluralSuffix &&
                rule.numbers.length === 2 &&
                rule.numbers[0] === 1) {
                return returnSuffix();
            }
            return this.options.prepend && idx.toString()
                ? this.options.prepend + idx.toString()
                : idx.toString();
        }
        //   this.logger.warn(`no plural rule found for: ${code}`);
        return '';
    }
}

const QUICK_START_NAME = 'console.openshift.io/name';
const getQuickStartByName = (name, quickStarts) => quickStarts.find((quickStart) => quickStart.metadata.name === name);
const getQuickStartStatus = (allQuickStartStates, quickStartID) => { var _a, _b; return (_b = (_a = allQuickStartStates === null || allQuickStartStates === void 0 ? void 0 : allQuickStartStates[quickStartID]) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : QuickStartStatus.NOT_STARTED; };
const getTaskStatusKey = (taskNumber) => `taskStatus${taskNumber}`;
const getQuickStartStatusCount = (allQuickStartStates, quickStarts) => quickStarts.reduce((totals, item) => {
    totals[getQuickStartStatus(allQuickStartStates, item.metadata.name)]++;
    return totals;
}, {
    [QuickStartStatus.IN_PROGRESS]: 0,
    [QuickStartStatus.COMPLETE]: 0,
    [QuickStartStatus.NOT_STARTED]: 0,
});
const getDisabledQuickStarts = () => {
    var _a, _b;
    let disabledQuickStarts = [];
    const quickStartServerData = (_a = window.SERVER_FLAGS) === null || _a === void 0 ? void 0 : _a.quickStarts;
    try {
        if (quickStartServerData) {
            disabledQuickStarts = (_b = JSON.parse(quickStartServerData).disabled) !== null && _b !== void 0 ? _b : [];
        }
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.error('error while parsing SERVER_FLAG.quickStarts', e);
    }
    return disabledQuickStarts;
};
const isDisabledQuickStart = (quickstart, disabledQuickStarts) => {
    var _a, _b;
    const quickStartName = (_b = (_a = quickstart.metadata.annotations) === null || _a === void 0 ? void 0 : _a[QUICK_START_NAME]) !== null && _b !== void 0 ? _b : quickstart.metadata.name;
    return disabledQuickStarts.includes(quickStartName);
};
const filterQuickStarts = (quickStarts, filterText, statusFilters, allQuickStartStates) => {
    const searchText = filterText.toLowerCase();
    return quickStarts.filter(({ metadata: { name }, spec: { displayName, prerequisites = [], description } }) => {
        const matchesFilter = statusFilters.length > 0
            ? statusFilters.includes(getQuickStartStatus(allQuickStartStates, name))
            : true;
        const matchesText = displayName.toLowerCase().includes(searchText) ||
            description.toLowerCase().includes(searchText) ||
            prerequisites.some((text) => text.toLowerCase().includes(searchText));
        return matchesFilter && matchesText;
    });
};
const camelize = (str) => str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
    if (+match === 0) {
        return '';
    } // or if (/\s+/.test(match)) for white spaces
    return index === 0 ? match.toLowerCase() : match.toUpperCase();
});

const pluralResolver = new PluralResolver({ simplifyPluralSuffix: true });
const getDefaultQuickStartState = (totalTasks, initialStatus) => {
    const defaultQuickStartState = {
        status: initialStatus || QuickStartStatus.NOT_STARTED,
        taskNumber: -1,
    };
    if (totalTasks) {
        for (let i = 0; i < totalTasks; i++) {
            defaultQuickStartState[getTaskStatusKey(i)] = QuickStartTaskStatus.INIT;
        }
    }
    return defaultQuickStartState;
};
const QuickStartContextDefaults = {
    allQuickStarts: [],
    activeQuickStartID: '',
    allQuickStartStates: {},
    activeQuickStartState: {},
    setAllQuickStarts: () => { },
    resourceBundle: en,
    getResource: (resource) => resource,
    language: 'en',
    useQueryParams: true,
    filter: {
        keyword: '',
        status: {
            statusTypes: {},
            statusFilters: [],
        },
    },
    setFilter: () => { },
    footer: null,
    useLegacyHeaderColors: false,
    markdown: null,
    loading: false,
    alwaysShowTaskReview: true,
    focusOnQuickStart: true,
};
const QuickStartContext = createContext(QuickStartContextDefaults);
const getResource = (resource, options, resourceBundle, lng) => {
    if (options && !isNaN(options.count)) {
        const suffix = pluralResolver.getSuffix(lng, options.count);
        if (suffix && resourceBundle[`${resource}_${suffix}`]) {
            // needs plural
            return resourceBundle[`${resource}_${suffix}`];
        }
    }
    return (resourceBundle && resourceBundle[resource]) || resource;
};
const useValuesForQuickStartContext = (value = {}) => {
    var _a, _b;
    const combinedValue = Object.assign(Object.assign({}, QuickStartContextDefaults), value);
    const { activeQuickStartID, setActiveQuickStartID, setAllQuickStartStates, useQueryParams, allQuickStartStates, allQuickStarts = [], footer, useLegacyHeaderColors, markdown, } = combinedValue;
    const [quickStarts, setQuickStarts] = useState(combinedValue.allQuickStarts || []);
    const [resourceBundle, setResourceBundle] = useState(Object.assign(Object.assign({}, en), combinedValue.resourceBundle));
    const [language, setLanguage] = useState(combinedValue.language);
    const changeResourceBundle = (bundle, lng) => {
        lng && setLanguage(lng);
        setResourceBundle(Object.assign(Object.assign({}, en), bundle));
    };
    const findResource = useCallback((resource, count) => getResource(resource, count !== undefined ? { count } : null, resourceBundle, language), [resourceBundle, language]);
    const [loading, setLoading] = useState(combinedValue.loading);
    const [alwaysShowTaskReview, setAlwaysShowTaskReview] = useState(combinedValue.alwaysShowTaskReview);
    const initialSearchParams = new URLSearchParams(window.location.search);
    const initialSearchQuery = initialSearchParams.get(QUICKSTART_SEARCH_FILTER_KEY) || '';
    const initialStatusFilters = ((_a = initialSearchParams.get(QUICKSTART_STATUS_FILTER_KEY)) === null || _a === void 0 ? void 0 : _a.split(',')) || [];
    const quickStartStatusCount = getQuickStartStatusCount(allQuickStartStates, allQuickStarts);
    const [statusTypes, setStatusTypes] = useState({
        [QuickStartStatus.COMPLETE]: findResource('Complete ({{statusCount, number}})').replace('{{statusCount, number}}', quickStartStatusCount[QuickStartStatus.COMPLETE]),
        [QuickStartStatus.IN_PROGRESS]: findResource('In progress ({{statusCount, number}})').replace('{{statusCount, number}}', quickStartStatusCount[QuickStartStatus.IN_PROGRESS]),
        [QuickStartStatus.NOT_STARTED]: findResource('Not started ({{statusCount, number}})').replace('{{statusCount, number}}', quickStartStatusCount[QuickStartStatus.NOT_STARTED]),
    });
    const [statusFilters, setStatusFilters] = useState(initialStatusFilters);
    const [filterKeyword, setFilterKeyword] = useState(initialSearchQuery);
    const setFilter = (type, val) => {
        if (type === 'keyword') {
            setFilterKeyword(val);
        }
        else if (type === 'status') {
            setStatusFilters(val);
        }
    };
    useEffect(() => {
        const updatedQuickStartStatusCount = getQuickStartStatusCount(allQuickStartStates, quickStarts);
        setStatusTypes({
            [QuickStartStatus.COMPLETE]: findResource('Complete ({{statusCount, number}})').replace('{{statusCount, number}}', updatedQuickStartStatusCount[QuickStartStatus.COMPLETE]),
            [QuickStartStatus.IN_PROGRESS]: findResource('In progress ({{statusCount, number}})').replace('{{statusCount, number}}', updatedQuickStartStatusCount[QuickStartStatus.IN_PROGRESS]),
            [QuickStartStatus.NOT_STARTED]: findResource('Not started ({{statusCount, number}})').replace('{{statusCount, number}}', updatedQuickStartStatusCount[QuickStartStatus.NOT_STARTED]),
        });
    }, [allQuickStartStates, findResource, quickStarts]);
    const updateAllQuickStarts = (qs) => {
        setQuickStarts(qs);
    };
    const setActiveQuickStart = useCallback((quickStartId, totalTasks) => {
        setActiveQuickStartID((id) => {
            if (!quickStartId || id === quickStartId) {
                useQueryParams && removeQueryArgument(QUICKSTART_ID_FILTER_KEY);
                return '';
            }
            useQueryParams && setQueryArgument(QUICKSTART_ID_FILTER_KEY, quickStartId);
            return quickStartId;
        });
        setAllQuickStartStates((qs) => !quickStartId || qs[quickStartId]
            ? qs
            : Object.assign(Object.assign({}, qs), { [quickStartId]: getDefaultQuickStartState(totalTasks) }));
    }, [setActiveQuickStartID, setAllQuickStartStates, useQueryParams]);
    const startQuickStart = useCallback((quickStartId, totalTasks) => {
        setActiveQuickStartID((id) => {
            if (!id || id !== quickStartId) {
                useQueryParams && setQueryArgument(QUICKSTART_ID_FILTER_KEY, quickStartId);
                return quickStartId;
            }
            useQueryParams && setQueryArgument(QUICKSTART_ID_FILTER_KEY, id);
            return id;
        });
        setAllQuickStartStates((qs) => {
            if (qs.hasOwnProperty(quickStartId)) {
                return Object.assign(Object.assign({}, qs), { [quickStartId]: Object.assign(Object.assign({}, qs[quickStartId]), { status: QuickStartStatus.IN_PROGRESS }) });
            }
            return Object.assign(Object.assign({}, qs), { [quickStartId]: getDefaultQuickStartState(totalTasks, QuickStartStatus.IN_PROGRESS) });
        });
    }, [setActiveQuickStartID, setAllQuickStartStates, useQueryParams]);
    const restartQuickStart = useCallback((quickStartId, totalTasks) => {
        setActiveQuickStartID((id) => {
            if (!id || id !== quickStartId) {
                useQueryParams && setQueryArgument(QUICKSTART_ID_FILTER_KEY, quickStartId);
                return quickStartId;
            }
            useQueryParams && setQueryArgument(QUICKSTART_ID_FILTER_KEY, id);
            return id;
        });
        setAllQuickStartStates((qs) => (Object.assign(Object.assign({}, qs), { [quickStartId]: getDefaultQuickStartState(totalTasks, QuickStartStatus.NOT_STARTED) })));
    }, [setActiveQuickStartID, setAllQuickStartStates, useQueryParams]);
    // When alwaysShowTaskReview preference is enabled, skip visited step and go directly to review
    const stepAfterInitial = alwaysShowTaskReview
        ? QuickStartTaskStatus.REVIEW
        : QuickStartTaskStatus.VISITED;
    const nextStep = useCallback((totalTasks) => {
        if (!activeQuickStartID) {
            return;
        }
        setAllQuickStartStates((qs) => {
            const quickStart = qs[activeQuickStartID];
            const status = quickStart === null || quickStart === void 0 ? void 0 : quickStart.status;
            const taskNumber = quickStart === null || quickStart === void 0 ? void 0 : quickStart.taskNumber;
            const taskStatus = quickStart[getTaskStatusKey(taskNumber)];
            let updatedStatus;
            let updatedTaskNumber;
            let updatedTaskStatus;
            if (status === QuickStartStatus.NOT_STARTED) {
                updatedStatus = QuickStartStatus.IN_PROGRESS;
            }
            else if (status === QuickStartStatus.IN_PROGRESS &&
                !QUICKSTART_TASKS_INITIAL_STATES.includes(taskStatus) &&
                taskNumber === totalTasks - 1) {
                updatedStatus = QuickStartStatus.COMPLETE;
            }
            if (taskStatus === QuickStartTaskStatus.VISITED) {
                updatedTaskStatus = QuickStartTaskStatus.REVIEW;
            }
            if (taskNumber < totalTasks && !updatedTaskStatus) {
                updatedTaskNumber = taskNumber + 1;
            }
            const markInitialStepVisitedOrReview = updatedTaskNumber > -1 &&
                quickStart[getTaskStatusKey(updatedTaskNumber)] === QuickStartTaskStatus.INIT
                ? stepAfterInitial
                : quickStart[getTaskStatusKey(updatedTaskNumber)];
            const newState = Object.assign(Object.assign({}, qs), { [activeQuickStartID]: Object.assign(Object.assign(Object.assign(Object.assign({}, quickStart), (updatedStatus ? { status: updatedStatus } : {})), (updatedTaskNumber > -1
                    ? {
                        taskNumber: updatedTaskNumber,
                        [getTaskStatusKey(updatedTaskNumber)]: markInitialStepVisitedOrReview,
                    }
                    : {})), (updatedTaskStatus ? { [getTaskStatusKey(taskNumber)]: updatedTaskStatus } : {})) });
            return newState;
        });
    }, [activeQuickStartID, setAllQuickStartStates, stepAfterInitial]);
    const previousStep = useCallback(() => {
        setAllQuickStartStates((qs) => {
            const quickStart = qs[activeQuickStartID];
            const taskNumber = quickStart === null || quickStart === void 0 ? void 0 : quickStart.taskNumber;
            if (taskNumber < 0) {
                return qs;
            }
            return Object.assign(Object.assign({}, qs), { [activeQuickStartID]: Object.assign(Object.assign({}, quickStart), { taskNumber: taskNumber - 1 }) });
        });
    }, [activeQuickStartID, setAllQuickStartStates]);
    const setQuickStartTaskNumber = useCallback((quickStartId, taskNumber) => {
        setAllQuickStartStates((qs) => {
            const quickStart = qs[quickStartId];
            const status = quickStart === null || quickStart === void 0 ? void 0 : quickStart.status;
            let updatedStatus;
            if (taskNumber > -1 && status === QuickStartStatus.NOT_STARTED) {
                updatedStatus = QuickStartStatus.IN_PROGRESS;
            }
            let updatedTaskStatus = {};
            for (let taskIndex = 0; taskIndex <= taskNumber; taskIndex++) {
                const taskStatus = quickStart[getTaskStatusKey(taskIndex)];
                const newTaskStatus = taskStatus === QuickStartTaskStatus.INIT ? stepAfterInitial : undefined;
                if (newTaskStatus) {
                    updatedTaskStatus = Object.assign(Object.assign({}, updatedTaskStatus), { [getTaskStatusKey(taskIndex)]: newTaskStatus });
                }
            }
            const updatedQuickStart = Object.assign(Object.assign(Object.assign(Object.assign({}, quickStart), (updatedStatus ? { status: updatedStatus } : {})), { taskNumber }), updatedTaskStatus);
            return Object.assign(Object.assign({}, qs), { [quickStartId]: updatedQuickStart });
        });
    }, [setAllQuickStartStates, stepAfterInitial]);
    const setQuickStartTaskStatus = useCallback((taskStatus) => {
        const quickStart = allQuickStartStates[activeQuickStartID];
        const { taskNumber } = quickStart;
        const updatedQuickStart = Object.assign(Object.assign({}, quickStart), { [getTaskStatusKey(taskNumber)]: taskStatus });
        setAllQuickStartStates((qs) => (Object.assign(Object.assign({}, qs), { [activeQuickStartID]: updatedQuickStart })));
    }, [allQuickStartStates, activeQuickStartID, setAllQuickStartStates]);
    const activeQuickStartState = (_b = allQuickStartStates === null || allQuickStartStates === void 0 ? void 0 : allQuickStartStates[activeQuickStartID]) !== null && _b !== void 0 ? _b : {};
    const getQuickStartForId = useCallback((id) => allQuickStartStates[id], [allQuickStartStates]);
    return {
        allQuickStarts: quickStarts,
        setAllQuickStarts: updateAllQuickStarts,
        activeQuickStartID,
        setActiveQuickStartID,
        allQuickStartStates,
        setAllQuickStartStates,
        activeQuickStartState,
        setActiveQuickStart: value.setActiveQuickStart || setActiveQuickStart,
        startQuickStart: value.startQuickStart || startQuickStart,
        restartQuickStart: value.restartQuickStart || restartQuickStart,
        nextStep: value.nextStep || nextStep,
        previousStep: value.previousStep || previousStep,
        setQuickStartTaskNumber,
        setQuickStartTaskStatus,
        getQuickStartForId,
        footer,
        useLegacyHeaderColors,
        useQueryParams,
        markdown,
        resourceBundle,
        getResource: findResource,
        setResourceBundle: changeResourceBundle,
        language,
        setLanguage,
        // revisit if this should be in public context API
        filter: {
            keyword: filterKeyword,
            status: {
                statusTypes,
                statusFilters,
            },
        },
        setFilter,
        loading,
        setLoading,
        alwaysShowTaskReview,
        setAlwaysShowTaskReview,
    };
};
const QuickStartContextProvider = ({ children, value }) => (jsx(QuickStartContext.Provider, Object.assign({ value: useValuesForQuickStartContext(value) }, { children: children })));

const Box = ({ children, className }) => (jsx("div", Object.assign({ className: css('pfext-status-box', className) }, { children: children })));
const Loading = ({ className }) => (jsxs("div", Object.assign({ className: css('pfext-m-loader', className) }, { children: [jsx("div", { className: "pfext-m-loader-dot__one" }), jsx("div", { className: "pfext-m-loader-dot__two" }), jsx("div", { className: "pfext-m-loader-dot__three" })] })));
Loading.displayName = 'Loading';
const LoadingBox = ({ className, message }) => (jsxs(Box, Object.assign({ className: css('pfext-status-box--loading', className) }, { children: [jsx(Loading, {}), message && jsx("div", Object.assign({ className: "pfext-status-box__loading-message" }, { children: message }))] })));
LoadingBox.displayName = 'LoadingBox';
const EmptyBox = ({ label }) => {
    const { getResource } = useContext(QuickStartContext);
    return (jsx(Box, { children: jsx("div", Object.assign({ "data-test": "empty-message", className: "text-center" }, { children: label
                ? getResource('No {{label}} found').replace('{{label}}', label)
                : getResource('Not found') })) }));
};
EmptyBox.displayName = 'EmptyBox';

const MEMO = {};
const CamelCaseWrap = ({ value, dataTest }) => {
    if (!value) {
        return '-';
    }
    if (MEMO[value]) {
        return MEMO[value];
    }
    // Add word break points before capital letters (but keep consecutive capital letters together).
    const words = value.match(/[A-Z]+[^A-Z]*|[^A-Z]+/g);
    const rendered = (jsx("span", Object.assign({ "data-test": dataTest }, { children: words.map((word, i) => (jsxs(Fragment, { children: [word, i !== words.length - 1 && jsx("wbr", {})] }, i))) })));
    MEMO[value] = rendered;
    return rendered;
};

const Modal = (_a) => {
    var { isFullScreen = false, className } = _a, props = __rest(_a, ["isFullScreen", "className"]);
    return (jsx(Modal$1, Object.assign({}, props, { className: css('pfext-modal', className), appendTo: () => (isFullScreen ? document.body : document.querySelector('#modal-container')) })));
};

const getContainer = (container) => typeof container === 'function' ? container() : container;
const Portal = ({ children, container }) => {
    const [containerNode, setContainerNode] = useState();
    useIsomorphicLayoutEffect(() => {
        setContainerNode(getContainer(container) || document.body);
    }, [container]);
    return containerNode ? createPortal(children, containerNode) : null;
};

const SimplePopper = ({ children }) => {
    const openProp = true;
    const nodeRef = useRef(null);
    const popperRef = useRef(null);
    const [isOpen, setOpenState] = useState(openProp);
    const setOpen = useCallback((newOpen) => {
        setOpenState(newOpen);
    }, []);
    useEffect(() => {
        setOpen(openProp);
    }, [openProp, setOpen]);
    const onKeyDown = useCallback((e) => {
        if (e.keyCode === 27) {
            setOpen(false);
        }
    }, [setOpen]);
    const onClickOutside = useCallback((e) => {
        if (!nodeRef.current || (e.target instanceof Node && !nodeRef.current.contains(e.target))) {
            setOpen(false);
        }
    }, [setOpen]);
    const destroy = useCallback(() => {
        if (popperRef.current) {
            popperRef.current.destroy();
            document.removeEventListener('keydown', onKeyDown, true);
            document.removeEventListener('mousedown', onClickOutside, true);
            document.removeEventListener('touchstart', onClickOutside, true);
        }
    }, [onClickOutside, onKeyDown]);
    const initialize = useCallback(() => {
        if (!nodeRef.current || !isOpen) {
            return;
        }
        destroy();
    }, [isOpen, destroy]);
    const nodeRefCallback = useCallback((node) => {
        nodeRef.current = node;
        initialize();
    }, [initialize]);
    useEffect(() => {
        initialize();
    }, [initialize]);
    useEffect(() => () => {
        destroy();
    }, [destroy]);
    useEffect(() => {
        if (!isOpen) {
            destroy();
        }
    }, [destroy, isOpen]);
    return isOpen ? (jsx(Portal, { children: jsx("div", Object.assign({ ref: nodeRefCallback, style: { zIndex: 9999, position: 'absolute', top: 0, left: 0 }, className: "pfext-quick-start__base" }, { children: children })) })) : null;
};

const isInViewport = (elementToCheck) => {
    const rect = elementToCheck.getBoundingClientRect();
    return (rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth));
};
const InteractiveSpotlight = ({ element }) => {
    const { top, bottom, left, right, height, width } = element.getBoundingClientRect();
    const style = {
        height,
        width,
        top,
        left,
        bottom,
        right,
    };
    const [clicked, setClicked] = useState(false);
    useEffect(() => {
        if (!clicked) {
            if (!isInViewport(element)) {
                element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
            }
            const handleClick = () => setClicked(true);
            document.addEventListener('click', handleClick);
            return () => {
                document.removeEventListener('click', handleClick);
            };
        }
        return () => { };
    }, [element, clicked]);
    if (clicked) {
        return null;
    }
    return (jsx(Portal, { children: jsx(SimplePopper, { children: jsx("div", { className: "pfext-spotlight pfext-spotlight__element-highlight-animate", style: style }) }) }));
};

var ScrollDirection;
(function (ScrollDirection) {
    ScrollDirection["scrollingUp"] = "scrolling-up";
    ScrollDirection["scrollingDown"] = "scrolling-down";
    ScrollDirection["scrolledToBottom"] = "scrolled-to-bottom";
    ScrollDirection["scrolledToTop"] = "scrolled-to-top";
})(ScrollDirection || (ScrollDirection = {}));

const useResizeObserver = (callback, targetElement, observerOptions = undefined) => {
    const element = useMemo(() => targetElement !== null && targetElement !== void 0 ? targetElement : document.querySelector('body'), [targetElement]);
    useEffect(() => {
        const observer = new ResizeObserver(callback);
        observer.observe(element, observerOptions);
        return () => {
            observer.disconnect();
        };
    }, [callback, observerOptions, element]);
};

var Shadows;
(function (Shadows) {
    Shadows["none"] = "none";
    Shadows["both"] = "both";
    Shadows["top"] = "top";
    Shadows["bottom"] = "bottom";
})(Shadows || (Shadows = {}));

const useBoundingClientRect = (targetElement) => {
    const [clientRect, setClientRect] = useState(() => targetElement ? targetElement.getBoundingClientRect() : null);
    const observerCallback = useCallback(() => {
        setClientRect(targetElement ? targetElement.getBoundingClientRect() : null);
    }, [targetElement]);
    useResizeObserver(observerCallback);
    return clientRect;
};

/**
 * React hook that forces component render.
 */
const useForceRender = () => useReducer((s) => !s, false)[1];

const useEventListener = (target, event, callback) => {
    useEffect(() => {
        target.addEventListener(event, callback);
        return () => {
            target.removeEventListener(event, callback);
        };
    }, [target, event, callback]);
};

const StaticSpotlight = ({ element }) => {
    const clientRect = useBoundingClientRect(element);
    const style = clientRect
        ? {
            top: clientRect.top,
            left: clientRect.left,
            height: clientRect.height,
            width: clientRect.width,
        }
        : {};
    return clientRect ? (jsx(Portal, { children: jsx("div", Object.assign({ className: "pf-v6-c-backdrop pfext-spotlight__with-backdrop" }, { children: jsx("div", { className: "pfext-spotlight pfext-spotlight__element-highlight-noanimate", style: style }) })) })) : null;
};

const Spotlight = ({ selector, interactive }) => {
    // if target element is a hidden one return null
    const element = useMemo(() => {
        const highlightElement = document.querySelector(selector);
        let hiddenElement = highlightElement;
        while (hiddenElement) {
            const ariaHidden = hiddenElement.getAttribute('aria-hidden');
            if (ariaHidden === 'true') {
                return null;
            }
            hiddenElement = hiddenElement.parentElement;
        }
        return highlightElement;
    }, [selector]);
    if (!element) {
        return null;
    }
    return interactive ? (jsx(InteractiveSpotlight, { element: element })) : (jsx(StaticSpotlight, { element: element }));
};

const MarkdownHighlightExtension = ({ docContext, rootSelector, }) => {
    const [selector, setSelector] = useState(null);
    useEffect(() => {
        const elements = docContext.querySelectorAll(`${rootSelector} [data-highlight]`);
        let timeoutId;
        function startHighlight(e) {
            const highlightId = e.target.getAttribute('data-highlight');
            if (!highlightId) {
                return;
            }
            setSelector(null);
            timeoutId = setTimeout(() => {
                setSelector(`[data-quickstart-id="${highlightId}"]`);
            }, 0);
        }
        elements && elements.forEach((elm) => elm.addEventListener('click', startHighlight));
        return () => {
            clearTimeout(timeoutId);
            elements && elements.forEach((elm) => elm.removeEventListener('click', startHighlight));
        };
    }, [docContext, rootSelector]);
    useEffect(() => {
        const elements = docContext.querySelectorAll(`${rootSelector} [class^=data-highlight__]`);
        let timeoutId;
        function startHighlight(e) {
            e.preventDefault();
            const classes = e.target.getAttribute('class').split(' ');
            let highlightId;
            for (const className of classes) {
                if (className.startsWith('data-highlight__')) {
                    highlightId = className.split('__')[1];
                    break;
                }
            }
            if (!highlightId) {
                return;
            }
            setSelector(null);
            timeoutId = setTimeout(() => {
                setSelector(`[data-quickstart-id="${highlightId}"]`);
            }, 0);
        }
        elements && elements.forEach((elm) => elm.addEventListener('click', startHighlight));
        return () => {
            clearTimeout(timeoutId);
            elements && elements.forEach((elm) => elm.removeEventListener('click', startHighlight));
        };
    }, [docContext, rootSelector]);
    if (!selector) {
        return null;
    }
    return jsx(Spotlight, { selector: selector, interactive: true });
};

const MARKDOWN_COPY_BUTTON_ID = 'data-copy-for';
const MARKDOWN_SNIPPET_ID = 'data-snippet-id';
const ACCORDION_MARKDOWN_BUTTON_ID = `accordion-markdown-button-id`;
const ACCORDION_MARKDOWN_CONTENT_ID = `accordion-markdown-content-id`;

const CopyClipboard = ({ element, rootSelector, docContext }) => {
    const { getResource } = useContext(QuickStartContext);
    const [showSuccessContent, setShowSuccessContent] = useState(false);
    const textToCopy = useMemo(() => {
        var _a;
        const copyTextId = element.getAttribute(MARKDOWN_COPY_BUTTON_ID);
        return (_a = docContext.querySelector(`${rootSelector} [${MARKDOWN_SNIPPET_ID}="${copyTextId}"]`)) === null || _a === void 0 ? void 0 : _a.innerText;
    }, [element, docContext, rootSelector]);
    useEventListener(element, 'click', useCallback(() => {
        navigator.clipboard
            .writeText(textToCopy.trim())
            .then(() => {
            setShowSuccessContent(true);
        })
            .catch(() => { });
    }, [textToCopy]));
    useEventListener(element, 'mouseleave', useCallback(() => {
        setShowSuccessContent(false);
    }, []));
    return showSuccessContent ? (jsx(Tooltip, { isVisible: true, triggerRef: () => element, content: getResource('Successfully copied to clipboard!'), className: "pfext-quick-start__base" }, "after-copy")) : (jsx(Tooltip, { triggerRef: () => element, content: getResource('Copy to clipboard'), className: "pfext-quick-start__base" }, "before-copy"));
};
const MarkdownCopyClipboard = ({ docContext, rootSelector }) => {
    const elements = docContext.querySelectorAll(`${rootSelector} [${MARKDOWN_COPY_BUTTON_ID}]`);
    return elements.length > 0 ? (jsx(Fragment$1, { children: Array.from(elements).map((elm) => {
            const attributeValue = elm.getAttribute(MARKDOWN_COPY_BUTTON_ID);
            return (jsx(CopyClipboard, { element: elm, rootSelector: rootSelector, docContext: docContext }, attributeValue));
        }) })) : null;
};

const removeTemplateWhitespace = (template) => template.replace(/>(?:\s|\n)+</g, '><');

const useInlineCopyClipboardShowdownExtension = () => {
    const { getResource } = useContext(QuickStartContext);
    return useMemo(() => ({
        type: 'lang',
        regex: /`([^`](.*?)[^`])`{{copy}}/g,
        replace: (text, group, _, groupId) => {
            if (!group || isNaN(groupId)) {
                return text;
            }
            return removeTemplateWhitespace(`<span class="pf-v6-c-clipboard-copy pf-m-inline">
              <span class="pf-v6-c-clipboard-copy__text" ${MARKDOWN_SNIPPET_ID}="${groupId}">${group}</span>
              <span class="pf-v6-c-clipboard-copy__actions">
                <span class="pf-v6-c-clipboard-copy__actions-item">
                  <button class="pf-v6-c-button pf-m-plain" aria-label="${getResource('Copy to clipboard')}" ${MARKDOWN_COPY_BUTTON_ID}="${groupId}">
                    ${renderToStaticMarkup(jsx(CopyIcon, {}))}
                  </button>
                </span>
              </span>
            </span>`);
        },
    }), [getResource]);
};

const useMultilineCopyClipboardShowdownExtension = () => {
    const { getResource } = useContext(QuickStartContext);
    return useMemo(() => ({
        type: 'lang',
        regex: /```[\n]\s*((((?!```).)*?\n)+)\s*```{{copy}}/g,
        replace: (text, group, _1, _2, groupId) => {
            if (!group || isNaN(groupId)) {
                return text;
            }
            return `<div class="pf-v6-c-code-block">
              <div class="pf-v6-c-code-block__header">
                <div class="pf-v6-c-code-block__actions">
                  <div class="pf-v6-c-code-block__actions-item">
                    <button class="pf-v6-c-button pf-m-plain" type="button" aria-label="${getResource('Copy to clipboard')}" ${MARKDOWN_COPY_BUTTON_ID}="${groupId}">
                      ${renderToStaticMarkup(jsx(CopyIcon, {}))}
                    </button>
                  </div>
                </div>
              </div>
              <div class="pf-v6-c-code-block__content">
                <pre class="pf-v6-c-code-block__pre pfext-code-block__pre"><code class="pf-v6-c-code-block__code"${MARKDOWN_SNIPPET_ID}="${groupId}">${group.trim()}</code></pre>
              </div>
            </div>`;
        },
    }), [getResource]);
};

// eslint-disable-next-line @typescript-eslint/no-require-imports
const DOMPurify$2 = require('dompurify');
var AdmonitionType;
(function (AdmonitionType) {
    AdmonitionType["TIP"] = "TIP";
    AdmonitionType["NOTE"] = "NOTE";
    AdmonitionType["IMPORTANT"] = "IMPORTANT";
    AdmonitionType["WARNING"] = "WARNING";
    AdmonitionType["CAUTION"] = "CAUTION";
})(AdmonitionType || (AdmonitionType = {}));
const admonitionToAlertVariantMap = {
    [AdmonitionType.NOTE]: { variant: 'info' },
    [AdmonitionType.TIP]: { variant: 'custom', customIcon: jsx(LightbulbIcon, {}) },
    [AdmonitionType.IMPORTANT]: { variant: 'danger' },
    [AdmonitionType.CAUTION]: { variant: 'warning', customIcon: jsx(FireIcon, {}) },
    [AdmonitionType.WARNING]: { variant: 'warning' },
};
const useAdmonitionShowdownExtension = () => 
// const { getResource } = React.useContext<QuickStartContextValues>(QuickStartContext);
useMemo(() => ({
    type: 'lang',
    regex: /\[(.+)]{{(admonition) ([\w-]+)}}/g,
    replace: (text, content, admonitionLabel, admonitionType) => {
        if (!content || !admonitionLabel || !admonitionType) {
            return text;
        }
        if (admonitionLabel !== 'admonition') {
            return text;
        }
        admonitionType = admonitionType.toUpperCase();
        // Process markdown content directly using marked
        const processedContent = marked.parseInline(content);
        const sanitizedContent = DOMPurify$2.sanitize(processedContent);
        // Handle unknown admonition types by defaulting to NOTE
        const admonitionConfig = admonitionToAlertVariantMap[admonitionType] || admonitionToAlertVariantMap.NOTE;
        const { variant, customIcon } = admonitionConfig;
        const pfAlert = (jsx(Alert, Object.assign({ variant: variant }, (customIcon && { customIcon }), { isInline: true, title: admonitionType, className: "pfext-markdown-admonition" }, { children: jsx("div", { dangerouslySetInnerHTML: { __html: sanitizedContent } }) })));
        return removeTemplateWhitespace(renderToStaticMarkup(pfAlert));
    },
}), []);

const useCodeShowdownExtension = () => useMemo(() => ({
    type: 'output',
    regex: /<pre><code>(.*?)\n?<\/code><\/pre>/g,
    replace: (text, content) => {
        if (!content) {
            return text;
        }
        const pfCodeBlock = jsx(CodeBlock, { children: content });
        return removeTemplateWhitespace(renderToStaticMarkup(pfCodeBlock));
    },
}), []);

// eslint-disable-next-line @typescript-eslint/no-require-imports
const DOMPurify$1 = require('dompurify');
const useAccordionShowdownExtension = () => useMemo(() => ({
    type: 'lang',
    regex: /\[(.+)]{{(accordion) (&quot;(.*?)&quot;)}}/g,
    replace: (_text, accordionContent, _command, _quotedHeading, accordionHeading) => {
        const accordionId = String(accordionHeading).replace(/\s/g, '-');
        // Process accordion content with markdown
        const processedContent = marked.parseInline(accordionContent);
        const sanitizedContent = DOMPurify$1.sanitize(processedContent);
        return removeTemplateWhitespace(renderToStaticMarkup(jsx(Accordion, { children: jsxs(AccordionItem, { children: [jsx(AccordionToggle, Object.assign({ id: `${ACCORDION_MARKDOWN_BUTTON_ID}-${accordionId}` }, { children: accordionHeading })), jsx(AccordionContent, Object.assign({ id: `${ACCORDION_MARKDOWN_CONTENT_ID}-${accordionId}`, hidden: true }, { children: jsx("div", { dangerouslySetInnerHTML: { __html: sanitizedContent } }) }))] }) })));
    },
}), []);

const AccordionShowdownHandler = ({ buttonElement, contentElement, }) => {
    const [expanded, setExpanded] = useState(false);
    const handleClick = () => {
        const newExpanded = !expanded;
        const expandedModifier = 'pf-m-expanded';
        // Find the accordion item element (parent of the button)
        const accordionItem = buttonElement.closest('.pf-v6-c-accordion__item');
        // Update button - both visual state and aria-expanded
        buttonElement.className = `pf-v6-c-accordion__toggle ${newExpanded ? expandedModifier : ''}`;
        buttonElement.setAttribute('aria-expanded', newExpanded.toString());
        // Update content - both visual state and hidden attribute
        contentElement.hidden = !newExpanded;
        contentElement.className = `pf-v6-c-accordion__expandable-content ${newExpanded ? expandedModifier : ''}`;
        // Update accordion item
        if (accordionItem) {
            accordionItem.className = `pf-v6-c-accordion__item ${newExpanded ? expandedModifier : ''}`;
        }
        setExpanded(newExpanded);
    };
    useEventListener(buttonElement, 'click', handleClick);
    return jsx(Fragment$1, {});
};
const AccordionRenderExtension = ({ docContext }) => {
    const buttonElements = docContext.querySelectorAll(`[id ^= ${ACCORDION_MARKDOWN_BUTTON_ID}]`);
    const contentElements = docContext.querySelectorAll(`[id ^= ${ACCORDION_MARKDOWN_CONTENT_ID}]`);
    return buttonElements.length > 0 ? (jsx(Fragment$1, { children: Array.from(buttonElements).map((elm) => {
            const content = Array.from(contentElements).find((elm2) => {
                const elmId = elm.id.split(ACCORDION_MARKDOWN_BUTTON_ID)[1];
                const elm2Id = elm2.id.split(ACCORDION_MARKDOWN_CONTENT_ID)[1];
                return elmId === elm2Id;
            });
            return (jsx(AccordionShowdownHandler, { buttonElement: elm, contentElement: content }, elm.id.split(ACCORDION_MARKDOWN_BUTTON_ID)[1]));
        }) })) : null;
};

const FallbackImg = ({ src, alt, className, fallback }) => {
    const [isSrcValid, setIsSrcValid] = useState(true);
    if (src && isSrcValid) {
        return jsx("img", { className: className, src: src, alt: alt, onError: () => setIsSrcValid(false) });
    }
    return jsx(Fragment$1, { children: fallback });
};

const DASH = '-';

const PopoverStatus = ({ hideHeader, children, isVisible = null, statusBody, title, onHide, onShow, }) => (jsx(Popover, Object.assign({ position: PopoverPosition.right, headerContent: hideHeader ? null : title, bodyContent: children, "aria-label": title, onHide: onHide, onShow: onShow, isVisible: isVisible }, { children: jsx(Button, Object.assign({ variant: "link", isInline: true }, { children: statusBody })) })));

const StatusIconAndText = ({ icon, title, spin, iconOnly, noTooltip, className, }) => {
    if (!title) {
        return jsx(Fragment$1, { children: DASH });
    }
    return (jsxs("span", Object.assign({ className: css('pfext-icon-and-text', className), title: iconOnly && !noTooltip ? title : undefined }, { children: [icon &&
                cloneElement(icon, {
                    className: css(spin && 'fa-spin', icon.props.className, !iconOnly && 'pfext-icon-and-text__icon pfext-icon-flex-child'),
                }), !iconOnly && jsx(CamelCaseWrap, { value: title, dataTest: "status-text" })] })));
};

const GenericStatus = (props) => {
    const { Icon, children, popoverTitle, title, noTooltip, iconOnly } = props, restProps = __rest(props, ["Icon", "children", "popoverTitle", "title", "noTooltip", "iconOnly"]);
    const renderIcon = iconOnly && !noTooltip ? jsx(Icon, { title: title }) : jsx(Icon, {});
    const statusBody = (jsx(StatusIconAndText, Object.assign({}, restProps, { noTooltip: noTooltip, title: title, iconOnly: iconOnly, icon: renderIcon })));
    return Children.toArray(children).length ? (jsx(PopoverStatus, Object.assign({ title: popoverTitle || title }, restProps, { statusBody: statusBody }, { children: children }))) : (statusBody);
};

const GreenCheckCircleIcon = ({ className, title, size }) => (jsx(Icon, Object.assign({ size: size, status: "success" }, { children: jsx(CheckCircleIcon, { "data-test": "success-icon", className: className, title: title }) })));

const SuccessStatus = (props) => (jsx(GenericStatus, Object.assign({}, props, { Icon: GreenCheckCircleIcon, title: props.title || 'Healthy' })));
SuccessStatus.displayName = 'SuccessStatus';

const Status = ({ status, title, iconOnly, noTooltip, className }) => {
    const statusProps = { title: title || status, iconOnly, noTooltip, className };
    switch (status) {
        case 'In Progress':
            return jsx(StatusIconAndText, Object.assign({}, statusProps, { icon: jsx(SyncAltIcon, {}) }));
        case 'Complete':
            return jsx(SuccessStatus, Object.assign({}, statusProps));
        default:
            return jsx(Fragment$1, { children: status || DASH });
    }
};
const StatusIcon = ({ status }) => jsx(Status, { status: status, iconOnly: true });

// eslint-disable-next-line @typescript-eslint/no-require-imports
const DOMPurify = require('dompurify');
const markdownConvert = (markdown, extensions) => __awaiter(void 0, void 0, void 0, function* () {
    DOMPurify.addHook('beforeSanitizeElements', function (node) {
        // nodeType 1 = element type
        var _a;
        // transform anchor tags
        if (node.nodeType === 1 && node.nodeName.toLowerCase() === 'a') {
            node.setAttribute('rel', 'noopener noreferrer');
            return node;
        }
        // add PF content classes to standard elements (details blocks get handled separately)
        if (node.nodeType === 1) {
            const contentElements = [
                'ul',
                'ol',
                'p',
                'li',
                'hr',
                'h1',
                'h2',
                'h3',
                'h4',
                'h5',
                'h6',
                'blockquote',
                'pre',
                'dl',
                'dt',
                'dd',
                'table',
            ];
            if (contentElements.includes(node.nodeName.toLowerCase())) {
                // don't overwrite elements already being styled by PatternFly
                if (!((_a = node.getAttribute('class')) === null || _a === void 0 ? void 0 : _a.includes('pf-v6-c-'))) {
                    node.setAttribute('class', `pf-v6-c-content--${node.nodeName.toLowerCase()}`);
                    return node;
                }
            }
        }
    });
    // Add a hook to make all links open a new window
    DOMPurify.addHook('afterSanitizeAttributes', function (node) {
        // set all elements owning target to target=_blank
        if ('target' in node) {
            node.setAttribute('target', '_blank');
        }
        // set non-HTML/MathML links to xlink:show=new
        if (!node.hasAttribute('target') &&
            (node.hasAttribute('xlink:href') || node.hasAttribute('href'))) {
            node.setAttribute('xlink:show', 'new');
        }
    });
    const reverseString = (str) => str.split('').reverse().join('');
    // replace code fences that end in a double curly brace (which are used by our custom md extensions) with non
    // markdown formatting related tokens so that marked doesn't try to parse them as code spans
    //
    // we want to reverse the string before we do the substitution so that we only match the opening code fence which
    // corresponds to the closing code fence with the double curly brace
    const reversedMarkdown = reverseString(markdown);
    const reverseMarkdownWithSubstitutedCodeFences = reversedMarkdown.replace(/{{```((.|\n)*?)```/g, '{{@@@$1@@@');
    const markdownWithSubstitutedCodeFences = reverseString(reverseMarkdownWithSubstitutedCodeFences);
    // Fix malformed HTML entities early in the process
    let preprocessedMarkdown = markdownWithSubstitutedCodeFences;
    preprocessedMarkdown = preprocessedMarkdown
        .replace(/&nbsp([^;])/g, '&nbsp;$1')
        .replace(/&amp;nbsp;/g, '&nbsp;');
    preprocessedMarkdown = preprocessedMarkdown.replace(/&nbsp(?![;])/g, '&nbsp;');
    // Process content in segments to ensure markdown parsing continues after HTML blocks
    const htmlBlockRegex = /(<(?:details|div|section|article)[^>]*>[\s\S]*?<\/(?:details|div|section|article)>)/g;
    let parsedMarkdown = '';
    // Check if there are any HTML blocks
    if (htmlBlockRegex.test(preprocessedMarkdown)) {
        // Reset regex for actual processing
        htmlBlockRegex.lastIndex = 0;
        let lastIndex = 0;
        let match;
        while ((match = htmlBlockRegex.exec(preprocessedMarkdown)) !== null) {
            // Process markdown before the HTML block
            const markdownBefore = preprocessedMarkdown.slice(lastIndex, match.index).trim();
            if (markdownBefore) {
                const parsed = yield marked.parse(markdownBefore);
                parsedMarkdown += parsed;
            }
            // Process the HTML block: parse markdown content inside while preserving HTML structure
            let htmlBlock = match[1];
            // Find and process markdown content inside HTML tags
            const contentRegex = />(\s*[\s\S]*?)\s*</g;
            const contentMatches = [];
            let contentMatch;
            while ((contentMatch = contentRegex.exec(htmlBlock)) !== null) {
                const content = contentMatch[1];
                // Only process content that has markdown formatting but no extension syntax
                if (content.trim() &&
                    !content.includes('{{') &&
                    (content.includes('**') || content.includes('- ') || content.includes('\n'))) {
                    // This looks like markdown content without extensions - parse it as block content
                    const parsedContent = yield marked.parse(content.trim());
                    // Remove wrapping <p> tags if they exist since we're inside HTML already
                    const cleanedContent = parsedContent.replace(/^<p[^>]*>([\s\S]*)<\/p>[\s]*$/g, '$1');
                    contentMatches.push({
                        original: contentMatch[0],
                        replacement: `>${cleanedContent}<`,
                    });
                }
            }
            // Apply the content replacements
            contentMatches.forEach(({ original, replacement }) => {
                htmlBlock = htmlBlock.replace(original, replacement);
            });
            // Apply extensions (like admonitions) to the processed HTML block
            if (extensions) {
                extensions.forEach(({ regex, replace }) => {
                    if (regex) {
                        htmlBlock = htmlBlock.replace(regex, replace);
                    }
                });
            }
            parsedMarkdown += htmlBlock;
            lastIndex = htmlBlockRegex.lastIndex;
        }
        // Process any remaining markdown after the last HTML block
        const markdownAfter = preprocessedMarkdown.slice(lastIndex).trim();
        if (markdownAfter) {
            const parsed = yield marked.parse(markdownAfter);
            parsedMarkdown += parsed;
        }
    }
    else {
        // No HTML blocks found, process normally
        parsedMarkdown = yield marked.parse(preprocessedMarkdown);
    }
    // Swap the temporary tokens back to code fences before we run the extensions
    let md = parsedMarkdown.replace(/@@@/g, '```');
    if (extensions) {
        // Convert code spans back to md format before we run the custom extension regexes
        md = md.replace(/<code>(.*)<\/code>/g, '`$1`');
        extensions.forEach(({ regex, replace }, _index) => {
            if (regex) {
                md = md.replace(regex, replace);
            }
        });
        // Convert any remaining backticks back into code spans
        md = md.replace(/`(.*)`/g, '<code>$1</code>');
    }
    return DOMPurify.sanitize(md);
});
const SyncMarkdownView = ({ content, emptyMsg, extensions, renderExtension, exactHeight, inline, className, }) => {
    const { getResource } = useContext(QuickStartContext);
    const [markup, setMarkup] = useState('');
    useEffect(() => {
        function getMd() {
            return __awaiter(this, void 0, void 0, function* () {
                const md = yield markdownConvert(content || emptyMsg || getResource('Not available'), extensions);
                setMarkup(md);
            });
        }
        getMd();
    }, [content, emptyMsg, getResource, extensions]);
    const innerProps = {
        renderExtension: (extensions === null || extensions === void 0 ? void 0 : extensions.length) > 0 ? renderExtension : undefined,
        exactHeight,
        markup,
        isEmpty: !content,
        className,
    };
    return inline ? jsx(InlineMarkdownView, Object.assign({}, innerProps)) : jsx(IFrameMarkdownView, Object.assign({}, innerProps));
};
const uniqueId = (function () {
    let num = 0;
    return function (prefix) {
        const prefixStr = String(prefix) || '';
        num += 1;
        return prefixStr + num;
    };
})();
const RenderExtension = ({ renderExtension, selector, markup, docContext, }) => {
    const forceRender = useForceRender();
    const markupRef = useRef(null);
    const shouldRenderExtension = useCallback(() => {
        if (markupRef.current === markup) {
            return true;
        }
        markupRef.current = markup;
        return false;
    }, [markup]);
    /**
     * During a render cycle in which markup changes, renderExtension receives an old copy of document
     * because react is still updating the dom using `dangerouslySetInnerHTML` with latest markdown markup
     * which causes the component rendered by renderExtension to receive old copy of document
     * use forceRender to delay the rendering of extension by one render cycle
     */
    useEffect(() => {
        if (renderExtension) {
            forceRender();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [markup]);
    return (jsx(Fragment$1, { children: shouldRenderExtension() ? renderExtension === null || renderExtension === void 0 ? void 0 : renderExtension(docContext !== null && docContext !== void 0 ? docContext : document, selector) : null }));
};
const InlineMarkdownView = ({ markup, isEmpty, renderExtension, className, }) => {
    const id = useMemo(() => uniqueId('markdown'), []);
    return (jsxs("div", Object.assign({ className: css({ 'is-empty': isEmpty }, className), id: id }, { children: [jsx("div", { style: { marginBlockEnd: 'var(--pf-t-global--spacer--md)' }, dangerouslySetInnerHTML: { __html: markup } }), renderExtension && (jsx(RenderExtension, { renderExtension: renderExtension, selector: `#${id}`, markup: markup }))] })));
};
const IFrameMarkdownView = ({ exactHeight, markup, isEmpty, renderExtension, className, }) => {
    const [frame, setFrame] = useState();
    const [loaded, setLoaded] = useState(false);
    const updateTimeoutHandle = useRef(null);
    const updateDimensions = useCallback(() => {
        var _a;
        if (!((_a = frame === null || frame === void 0 ? void 0 : frame.contentWindow) === null || _a === void 0 ? void 0 : _a.document.body.firstChild)) {
            return;
        }
        frame.style.height = `${frame.contentWindow.document.body.firstElementChild.scrollHeight}px`;
        // Let the new height take effect, then reset again once we recompute
        updateTimeoutHandle.current = setTimeout(() => {
            if (exactHeight) {
                frame.style.height = `${frame.contentWindow.document.body.firstElementChild.scrollHeight}px`;
            }
            else {
                // Increase by 15px for the case where a horizontal scrollbar might appear
                frame.style.height = `${frame.contentWindow.document.body.firstElementChild.scrollHeight + 15}px`;
            }
        });
    }, [frame, exactHeight]);
    useEffect(() => () => {
        clearTimeout(updateTimeoutHandle.current);
    }, []);
    const onLoad = useCallback(() => {
        updateDimensions();
        setLoaded(true);
    }, [updateDimensions]);
    // Find the app's stylesheets and inject them into the frame to ensure consistent styling.
    const filteredLinks = Array.from(document.getElementsByTagName('link')).filter((l) => l.href.includes('app-bundle'));
    const linkRefs = filteredLinks.reduce((refs, link) => `${refs}
    <link rel="stylesheet" href="${link.href}">`, '');
    const contents = `
  ${linkRefs}
  <style type="text/css">
  body {
    background-color: transparent !important;
    color: ${isEmpty ? '#999' : '#333'};
    font-family: var(--pf-t--global--font--family--body);
    min-width: auto !important;
  }
  table {
    display: block;
    margin-bottom: 11.5px;
    overflow-x: auto;
  }
  td,
  th {
    border-bottom: 1px solid #ededed;
    padding: 10px;
    vertical-align: top;
  }
  th {
    padding-top: 0;
  }
  </style>
  <body class="pf-m-redhat-font"><div style="overflow-y: auto;">${markup}</div></body>`;
    return (jsxs(Fragment$1, { children: [jsx("iframe", { title: "Markdown content preview", sandbox: "allow-popups allow-popups-to-escape-sandbox allow-same-origin", srcDoc: contents, style: { border: '0px', display: 'block', width: '100%', height: '0' }, ref: (r) => {
                    setFrame(r);
                }, onLoad: () => onLoad(), className: className }), loaded && frame && renderExtension && (jsx(RenderExtension, { markup: markup, selector: '', renderExtension: renderExtension, docContext: frame.contentDocument }))] }));
};

const LINK_LABEL = '[\\d\\w\\s-()$!]+';
const HIGHLIGHT_ACTIONS = ['highlight'];
const SELECTOR_ID = `[\\w-]+`;
// [linkLabel]{{action id}}
const HIGHLIGHT_REGEXP = new RegExp(`\\[(${LINK_LABEL})]{{(${HIGHLIGHT_ACTIONS.join('|')}) (${SELECTOR_ID})}}`, 'g');

const QuickStartMarkdownView = ({ content, exactHeight, className, }) => {
    const { markdown } = useContext(QuickStartContext);
    const inlineCopyClipboardShowdownExtension = useInlineCopyClipboardShowdownExtension();
    const multilineCopyClipboardShowdownExtension = useMultilineCopyClipboardShowdownExtension();
    const admonitionShowdownExtension = useAdmonitionShowdownExtension();
    const codeShowdownExtension = useCodeShowdownExtension();
    const accordionShowdownExtension = useAccordionShowdownExtension();
    return (jsx(SyncMarkdownView, { inline: true, content: content, exactHeight: exactHeight, extensions: [
            {
                type: 'lang',
                regex: HIGHLIGHT_REGEXP,
                replace: (text, linkLabel, linkType, linkId) => {
                    if (!linkLabel || !linkType || !linkId) {
                        return text;
                    }
                    return `<button class="pf-v6-c-button pf-m-inline pf-m-link" data-highlight="${linkId}">${linkLabel}</button>`;
                },
            },
            {
                type: 'output',
                filter(text) {
                    // check HTML for patterns like: <em>Status: unknown</em>{#extension-requirement-status}
                    // and replace with <em id="extension-requirement-status">Status: unknown</em>
                    return text.replace(/<em>(.*)<\/em>{#(.*)}/g, '<em id="$2">$1</em>');
                },
            },
            inlineCopyClipboardShowdownExtension,
            multilineCopyClipboardShowdownExtension,
            admonitionShowdownExtension,
            codeShowdownExtension,
            accordionShowdownExtension,
            ...(markdown ? markdown.extensions : []),
        ], renderExtension: (docContext, rootSelector) => (jsxs(Fragment$1, { children: [jsx(AccordionRenderExtension, { docContext: docContext }), jsx(MarkdownHighlightExtension, { docContext: docContext, rootSelector: rootSelector }), jsx(MarkdownCopyClipboard, { docContext: docContext, rootSelector: rootSelector }), markdown &&
                    markdown.renderExtension &&
                    markdown.renderExtension(docContext, rootSelector)] })), className: className }));
};

const QuickStartTileDescription = ({ description, prerequisites, }) => {
    const { getResource } = useContext(QuickStartContext);
    const prereqs = prerequisites === null || prerequisites === void 0 ? void 0 : prerequisites.filter((p) => p);
    const buttonRef = useRef(null);
    return (jsxs(Fragment$1, { children: [jsx(QuickStartMarkdownView, { content: description }), (prereqs === null || prereqs === void 0 ? void 0 : prereqs.length) > 0 && (jsxs(Flex, Object.assign({ spaceItems: { default: 'spaceItemsSm' } }, { children: [jsxs("h5", { children: [getResource('Prerequisites ({{totalPrereqs}})').replace('{{totalPrereqs}}', prereqs.length), ' '] }), jsx(Button, Object.assign({ variant: "link", isInline: true, "data-testid": "qs-card-prereqs", ref: buttonRef, onClick: (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                        }, "aria-label": getResource('Show prerequisites') }, { children: jsx(InfoCircleIcon, {}) })), jsx(Popover, { "aria-label": getResource('Prerequisites'), headerContent: getResource('Prerequisites'), triggerRef: buttonRef, bodyContent: jsx("div", { children: jsx("ul", Object.assign({ "aria-label": getResource('Prerequisites') }, { children: prereqs.map((prerequisite, index) => (
                                // eslint-disable-next-line react/no-array-index-key
                                jsx("li", { children: jsx(QuickStartMarkdownView, { content: prerequisite }) }, index))) })) }) })] })))] }));
};

const QuickStartTileFooter = ({ quickStartId, status, totalTasks, onClickContinue, }) => {
    const { getResource } = useContext(QuickStartContext);
    const { activeQuickStartID, startQuickStart, restartQuickStart } = useContext(QuickStartContext);
    const start = useCallback(() => {
        startQuickStart(quickStartId, totalTasks);
    }, [quickStartId, startQuickStart, totalTasks]);
    const restart = useCallback(() => {
        restartQuickStart(quickStartId, totalTasks);
    }, [quickStartId, restartQuickStart, totalTasks]);
    return (jsxs(Flex, Object.assign({ justifyContent: { default: 'justifyContentSpaceBetween' } }, { children: [status === QuickStartStatus.NOT_STARTED && (jsx(FlexItem, { children: jsx(Button, Object.assign({ onClick: start, variant: "link", isInline: true, "data-testid": "qs-card-notStarted-start", id: `${quickStartId}-start`, "aria-labelledby": `${quickStartId}-start ${quickStartId}` }, { children: getResource('Start') })) })), status === QuickStartStatus.IN_PROGRESS && activeQuickStartID !== quickStartId && (jsx(FlexItem, { children: jsx(Button, Object.assign({ variant: "link", onClick: onClickContinue, isInline: true, "data-testid": "qs-card-inProgress-resume", id: `${quickStartId}-continue`, "aria-labelledby": `${quickStartId}-continue ${quickStartId}` }, { children: getResource('Continue') })) })), status === QuickStartStatus.COMPLETE && (jsx(FlexItem, { children: jsx(Button, Object.assign({ onClick: restart, variant: "link", isInline: true, "data-testid": "qs-card-complete-restart", id: `${quickStartId}-restart`, "aria-labelledby": `${quickStartId}-restart ${quickStartId}` }, { children: getResource('Restart') })) })), status === QuickStartStatus.IN_PROGRESS && (jsx(FlexItem, { children: jsx(Button, Object.assign({ onClick: restart, variant: "link", isInline: true, "data-testid": "qs-card-inProgress-restart", id: `${quickStartId}-restart`, "aria-labelledby": `${quickStartId}-restart ${quickStartId}` }, { children: getResource('Restart') })) }))] })));
};

const QuickStartTileFooterExternal = ({ link, quickStartId }) => {
    const { href, text } = link;
    return (jsx(Flex, Object.assign({ justifyContent: { default: 'justifyContentSpaceBetween' } }, { children: jsx(FlexItem, { children: jsx(Button, Object.assign({ component: "a", href: href, target: "_blank", rel: "noopener noreferrer", variant: "link", "aria-label": `Open documentation in new window`, isInline: true, icon: jsx(ExternalLinkAltIcon, {}), iconPosition: "right", id: quickStartId, "aria-labelledby": `${quickStartId}-external ${quickStartId}` }, { children: text || href })) }) })));
};

const QuickStartTileHeader = ({ name, quickStartId, onSelect }) => (jsx(Flex, Object.assign({ flexWrap: { default: 'nowrap' } }, { children: jsx(Button, Object.assign({ "data-test": "title", id: quickStartId, variant: "link", isInline: true, onClick: onSelect }, { children: name })) })));

const QuickStartTile = ({ quickStart, status, isActive, onClick = () => { }, action, }) => {
    const { metadata: { name: id }, spec: { icon, tasks, displayName, description, durationMinutes, prerequisites, link, type }, } = quickStart;
    const { setActiveQuickStart, footer, getResource } = useContext(QuickStartContext);
    const statusColorMap = {
        [QuickStartStatus.COMPLETE]: 'green',
        [QuickStartStatus.IN_PROGRESS]: 'purple',
        [QuickStartStatus.NOT_STARTED]: 'grey',
    };
    const statusLocaleMap = {
        [QuickStartStatus.COMPLETE]: getResource('Complete'),
        [QuickStartStatus.IN_PROGRESS]: getResource('In progress'),
        [QuickStartStatus.NOT_STARTED]: getResource('Not started'),
    };
    let quickStartIcon;
    if (typeof icon === 'object') {
        quickStartIcon = jsx(Icon, Object.assign({ size: "2xl" }, { children: icon }));
    }
    else {
        quickStartIcon = (jsx(Icon, Object.assign({ size: "2xl" }, { children: jsx(FallbackImg, { src: icon, alt: "", className: "pfext-catalog-item-icon__img", fallback: jsx(RocketIcon, {}) }) })));
    }
    const onSelect = () => {
        if (!link) {
            setActiveQuickStart(id, tasks === null || tasks === void 0 ? void 0 : tasks.length);
        }
        else {
            window.open(link.href, '_blank', 'noopener,noreferrer');
        }
        onClick();
    };
    const footerComponent = useMemo(() => {
        if (footer && footer.show === false) {
            return null;
        }
        if (link) {
            return jsx(QuickStartTileFooterExternal, { link: link, quickStartId: id });
        }
        return (jsx(QuickStartTileFooter, { quickStartId: id, status: status, totalTasks: tasks === null || tasks === void 0 ? void 0 : tasks.length, onClickContinue: onSelect }));
    }, [footer, id, link, status, tasks === null || tasks === void 0 ? void 0 : tasks.length]);
    const ActionIcon = (action === null || action === void 0 ? void 0 : action.icon) || OutlinedBookmarkIcon;
    const additionalAction = action ? (jsx(Button, Object.assign({ "aria-label": action['aria-label'], icon: jsx(ActionIcon, {}), variant: "plain", onClick: action.onClick }, action.buttonProps))) : undefined;
    return (jsxs(Card, Object.assign({ id: `${id}-catalog-tile`, style: { height: '100%' }, "data-testid": `qs-card-${camelize(displayName)}`, className: "pfext-catalog-item" }, (isActive && {
        isClickable: true,
        isSelectable: true,
        isSelected: true,
        isClicked: true,
    }), { children: [jsx(CardHeader, Object.assign({}, (action && {
                actions: { actions: additionalAction },
            }), { children: quickStartIcon })), jsx(CardTitle, { children: jsx(QuickStartTileHeader, { name: displayName, onSelect: onSelect, quickStartId: id }) }), jsx(CardBody, { children: jsxs(Stack, Object.assign({ hasGutter: true }, { children: [jsxs(Flex, Object.assign({ spaceItems: { default: 'spaceItemsSm' } }, { children: [type && jsx(Label, Object.assign({ color: type.color }, { children: type.text })), durationMinutes && (jsx(Label, Object.assign({ variant: "outline", "data-test": "duration", icon: jsx(OutlinedClockIcon, {}) }, { children: getResource('{{duration, number}} minutes', durationMinutes).replace('{{duration, number}}', durationMinutes) }))), status !== QuickStartStatus.NOT_STARTED && (jsx(Label, Object.assign({ variant: "outline", color: statusColorMap[status], icon: jsx(StatusIcon, { status: status }), "data-test": "status" }, { children: statusLocaleMap[status] })))] })), jsx(QuickStartTileDescription, { description: description, prerequisites: prerequisites })] })) }), jsx(CardFooter, { children: footerComponent })] })));
};

const QuickStartCatalog = ({ quickStarts }) => {
    const { activeQuickStartID, allQuickStartStates } = useContext(QuickStartContext);
    return (jsx("div", { children: jsx(Gallery, Object.assign({ hasGutter: true, className: "pfext-quick-start-catalog__gallery" }, { children: quickStarts.map((quickStart, index) => {
                const { metadata: { name: id }, } = quickStart;
                return (jsx(QuickStartTile, { quickStart: quickStart, isActive: id === activeQuickStartID, status: getQuickStartStatus(allQuickStartStates, id) }, index));
            }) })) }));
};

const QuickStartCatalogFilterSearch = (_a) => {
    var { searchInputText, handleTextChange } = _a, props = __rest(_a, ["searchInputText", "handleTextChange"]);
    const { getResource } = useContext(QuickStartContext);
    return (jsx(ToolbarItem, { children: jsx(SearchInput, Object.assign({ placeholder: getResource('Filter by keyword...'), value: searchInputText, onChange: (_ev, value) => handleTextChange(value), onClear: () => handleTextChange('') }, props)) }));
};
const QuickStartCatalogFilterSelect = (_a) => {
    var { isDropdownOpen, setIsDropdownOpen, onRowfilterSelect, selectedFilters, dropdownItems } = _a, props = __rest(_a, ["isDropdownOpen", "setIsDropdownOpen", "onRowfilterSelect", "selectedFilters", "dropdownItems"]);
    const { getResource } = useContext(QuickStartContext);
    const toggle = (toggleRef) => (jsxs(MenuToggle, Object.assign({ isFullWidth: true, ref: toggleRef, onClick: () => setIsDropdownOpen(!isDropdownOpen), isExpanded: isDropdownOpen }, { children: [getResource('Status'), selectedFilters.length > 0 && jsx(Badge, Object.assign({ isRead: true }, { children: selectedFilters.length }))] })));
    return (jsx(ToolbarItem, { children: jsx(Select, Object.assign({ "aria-label": getResource('Select filter'), isOpen: isDropdownOpen, selected: selectedFilters, onSelect: onRowfilterSelect, onOpenChange: (isOpen) => setIsDropdownOpen(isOpen), toggle: toggle }, props, { children: jsx(SelectList, { children: dropdownItems }) })) }));
};
const QuickStartCatalogFilterCount = ({ quickStartsCount }) => {
    const { getResource } = useContext(QuickStartContext);
    return (jsx(ToolbarItem, Object.assign({ align: { default: 'alignEnd' } }, { children: getResource("{{count, number}} item", quickStartsCount).replace('{{count, number}}', quickStartsCount) })));
};
const QuickStartCatalogFilterSearchWrapper = ({ onSearchInputChange = () => { } }) => {
    const { useQueryParams, filter, setFilter } = useContext(QuickStartContext);
    useEffect(() => {
        //   use this effect to clear the search when a `clear all` action is performed higher up
        const unlisten = history.listen(({ location }) => {
            const searchParams = new URLSearchParams(location.search);
            const searchQuery = searchParams.get(QUICKSTART_SEARCH_FILTER_KEY) || '';
            if (searchQuery === '') {
                setFilter('keyword', '');
                onSearchInputChange('');
            }
        });
        return () => {
            unlisten();
        };
    }, [onSearchInputChange, setFilter]);
    const handleTextChange = (val) => {
        if (val.length > 0) {
            useQueryParams && setQueryArgument(QUICKSTART_SEARCH_FILTER_KEY, val);
        }
        else {
            useQueryParams && removeQueryArgument(QUICKSTART_SEARCH_FILTER_KEY);
        }
        if ((filter === null || filter === void 0 ? void 0 : filter.keyword) !== val) {
            setFilter('keyword', val);
        }
        onSearchInputChange(val);
    };
    return (jsx(QuickStartCatalogFilterSearch, { searchInputText: filter === null || filter === void 0 ? void 0 : filter.keyword, handleTextChange: handleTextChange }));
};
// compare string/number arrays
const equalsIgnoreOrder = (a, b) => {
    if (a.length !== b.length) {
        return false;
    }
    const uniqueValues = new Set([...a, ...b]);
    for (const v of uniqueValues) {
        const aCount = a.filter((e) => e === v).length;
        const bCount = b.filter((e) => e === v).length;
        if (aCount !== bCount) {
            return false;
        }
    }
    return true;
};
const QuickStartCatalogFilterStatusWrapper = ({ onStatusChange = () => { } }) => {
    const { useQueryParams, filter, setFilter } = useContext(QuickStartContext);
    useEffect(() => {
        //   use this effect to clear the status when a `clear all` action is performed higher up
        const unlisten = history.listen(({ location }) => {
            var _a;
            const searchParams = new URLSearchParams(location.search);
            const updatedStatusFilters = ((_a = searchParams.get(QUICKSTART_STATUS_FILTER_KEY)) === null || _a === void 0 ? void 0 : _a.split(',')) || [];
            if (updatedStatusFilters.length === 0) {
                setFilter('status', []);
                onStatusChange([]);
            }
        });
        return () => {
            unlisten();
        };
    });
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const onRowfilterSelect = useCallback((_e, selectedValue) => {
        setIsDropdownOpen(false);
        const selection = Object.entries(filter.status.statusTypes).find(([_key, value]) => value === selectedValue)[0];
        const selectedFiltersList = filter.status.statusFilters.includes(selection)
            ? filter.status.statusFilters.filter((status) => status !== selection)
            : [...filter.status.statusFilters, selection];
        if (!equalsIgnoreOrder(filter.status.statusFilters, selectedFiltersList)) {
            setFilter('status', selectedFiltersList);
        }
        if (selectedFiltersList.length > 0) {
            useQueryParams && setQueryArgument('status', selectedFiltersList.join(','));
        }
        else {
            useQueryParams && removeQueryArgument(QUICKSTART_STATUS_FILTER_KEY);
        }
        onStatusChange(selectedFiltersList);
    }, [filter.status.statusFilters, onStatusChange, setFilter, useQueryParams]);
    const dropdownItems = Object.entries(filter.status.statusTypes).map(([key, value]) => (jsx(SelectOption, Object.assign({ "data-key": key, value: value, hasCheckbox: true, isSelected: filter.status.statusFilters.includes(key) }, { children: jsx(Fragment$1, { children: value }) }), key)));
    return (jsx(QuickStartCatalogFilterSelect, { isDropdownOpen: isDropdownOpen, setIsDropdownOpen: setIsDropdownOpen, onRowfilterSelect: onRowfilterSelect, selectedFilters: filter.status.statusFilters, dropdownItems: dropdownItems }));
};
const QuickStartCatalogFilterCountWrapper = ({ quickStartsCount, }) => jsx(QuickStartCatalogFilterCount, { quickStartsCount: quickStartsCount });

const QuickStartCatalogFilter = (_a) => {
    var { quickStartsCount, onSearchInputChange = () => { }, onStatusChange = () => { } } = _a, props = __rest(_a, ["quickStartsCount", "onSearchInputChange", "onStatusChange"]);
    return (jsx(Toolbar, Object.assign({}, props, { children: jsxs(ToolbarContent, { children: [jsx(QuickStartCatalogFilterSearchWrapper, { onSearchInputChange: onSearchInputChange }), jsx(QuickStartCatalogFilterStatusWrapper, { onStatusChange: onStatusChange }), jsx(QuickStartCatalogFilterCountWrapper, { quickStartsCount: quickStartsCount })] }) })));
};

const QuickStartCatalogEmptyState = ({ clearFilters }) => {
    const { getResource } = useContext(QuickStartContext);
    return (jsxs(EmptyState, Object.assign({ headingLevel: "h4", icon: SearchIcon, titleText: jsx(Fragment$1, { children: getResource('No results found') }) }, { children: [jsx(EmptyStateBody, { children: getResource('No results match the filter criteria. Remove filters or clear all filters to show results.') }), jsx(EmptyStateFooter, { children: jsx(EmptyStateActions, { children: jsx(Button, Object.assign({ variant: "link", onClick: clearFilters, "data-test": "clear-filter button" }, { children: getResource('Clear all filters') })) }) })] })));
};
const QuickStartCatalogPage = ({ quickStarts, showFilter, sortFnc = (q1, q2) => q1.spec.displayName.localeCompare(q2.spec.displayName), title, hint, showTitle = true, }) => {
    const sortFncCallback = useCallback(sortFnc, [sortFnc]);
    const { allQuickStarts = [], setAllQuickStarts, allQuickStartStates, getResource, filter, setFilter, loading, } = useContext(QuickStartContext);
    useEffect(() => {
        // passed through prop, not context
        if (quickStarts && JSON.stringify(quickStarts) !== JSON.stringify(allQuickStarts)) {
            setAllQuickStarts(quickStarts);
        }
    }, [quickStarts, allQuickStarts, setAllQuickStarts]);
    const initialFilteredQuickStarts = showFilter
        ? filterQuickStarts(allQuickStarts, filter.keyword, filter.status.statusFilters, allQuickStartStates).sort(sortFncCallback)
        : allQuickStarts;
    const [filteredQuickStarts, setFilteredQuickStarts] = useState(initialFilteredQuickStarts);
    useEffect(() => {
        const filteredQs = showFilter
            ? filterQuickStarts(allQuickStarts, filter.keyword, filter.status.statusFilters, allQuickStartStates).sort(sortFncCallback)
            : allQuickStarts;
        // also needs a check whether the content of the QS changed
        if (filteredQs.length !== filteredQuickStarts.length ||
            JSON.stringify(filteredQs) !== JSON.stringify(filteredQuickStarts)) {
            setFilteredQuickStarts(filteredQs);
        }
    }, [
        allQuickStarts,
        allQuickStartStates,
        showFilter,
        filter.keyword,
        filter.status.statusFilters,
        sortFncCallback,
        filteredQuickStarts,
    ]);
    const clearFilters = () => {
        setFilter('keyword', '');
        setFilter('status', []);
        clearFilterParams();
        setFilteredQuickStarts(allQuickStarts.sort((q1, q2) => q1.spec.displayName.localeCompare(q2.spec.displayName)));
    };
    const onSearchInputChange = (searchValue) => {
        const result = filterQuickStarts(allQuickStarts, searchValue, filter.status.statusFilters, allQuickStartStates).sort((q1, q2) => q1.spec.displayName.localeCompare(q2.spec.displayName));
        if (searchValue !== filter.keyword) {
            setFilter('keyword', searchValue);
        }
        if (result.length !== filteredQuickStarts.length) {
            setFilteredQuickStarts(result);
        }
    };
    const onStatusChange = (statusList) => {
        const result = filterQuickStarts(allQuickStarts, filter.keyword, statusList, allQuickStartStates).sort((q1, q2) => q1.spec.displayName.localeCompare(q2.spec.displayName));
        if (JSON.stringify(statusList) !== JSON.stringify(filter.status)) {
            setFilter('status', statusList);
        }
        if (result.length !== filteredQuickStarts.length) {
            setFilteredQuickStarts(result);
        }
    };
    if (loading) {
        return jsx(LoadingBox, {});
    }
    if (!allQuickStarts || allQuickStarts.length === 0) {
        return jsx(EmptyBox, { label: getResource('Quick Starts') });
    }
    return (jsxs(Fragment$1, { children: [(showTitle || showFilter) && (jsxs(PageSection, Object.assign({ hasBodyWrapper: false }, { children: [showTitle && (jsxs(Content, Object.assign({ isEditorial: true }, { children: [jsx(Title, Object.assign({ headingLevel: "h1", "data-test": "page-title" }, { children: title || getResource('Quick Starts') })), hint && jsx("div", { children: hint })] }))), showTitle && jsx(Divider, { component: "div" }), showFilter && (jsx(Fragment$1, { children: jsx(QuickStartCatalogFilter, { quickStartsCount: filteredQuickStarts.length, onSearchInputChange: onSearchInputChange, onStatusChange: onStatusChange }) }))] }))), jsx(PageSection, Object.assign({ hasBodyWrapper: false }, { children: filteredQuickStarts.length === 0 ? (jsx(QuickStartCatalogEmptyState, { clearFilters: clearFilters })) : (jsx(QuickStartCatalog, { quickStarts: filteredQuickStarts })) }))] }));
};

const QuickStartCatalogHeader = ({ title, hint, }) => (jsxs("div", { children: [jsx(Title, Object.assign({ headingLevel: "h1", "data-pf-content": "true" }, { children: title })), hint && jsx("div", { children: hint })] }));

const QuickStartCatalogSection = ({ children }) => (jsx("div", { children: children }));

const QuickStartCatalogToolbar = ({ children }) => (jsx(Toolbar, { children: children }));

const QuickStartCloseModal = ({ isOpen, onConfirm, onCancel }) => {
    const { getResource } = useContext(QuickStartContext);
    return (jsx(Modal, Object.assign({ isOpen: isOpen, variant: ModalVariant.small, showClose: false, "data-test": "leave-quickstart", title: getResource('Leave quick start?'), footer: jsxs(Flex, { children: [jsx(FlexItem, Object.assign({ align: { default: 'alignRight' } }, { children: jsx(Button, Object.assign({ variant: "secondary", "data-test": "cancel button", onClick: onCancel }, { children: getResource('Cancel') })) })), jsx(FlexItem, { children: jsx(Button, Object.assign({ variant: "primary", "data-test": "leave button", onClick: onConfirm }, { children: getResource('Leave') })) })] }), isFullScreen: true }, { children: getResource('Your progress will be saved.') })));
};

const QuickStartTaskHeader = ({ title, taskIndex, subtitle, taskStatus, size, isActiveTask, onTaskSelect, children, }) => {
    const titleRef = useRef(null);
    const { focusOnQuickStart } = useContext(QuickStartContext);
    useEffect(() => {
        if (focusOnQuickStart && isActiveTask) {
            // Focus the WizardNavItem button element that contains the title
            titleRef.current.parentNode.focus();
        }
    }, [focusOnQuickStart, isActiveTask]);
    const failedReview = taskStatus === QuickStartTaskStatus.FAILED;
    const tryAgain = failedReview && (jsxs(Fragment$1, { children: [jsx("div", {}), jsx("div", Object.assign({ className: "pfext-quick-start-task-header__tryagain" }, { children: "Try the steps again." }))] }));
    const content = (jsx("div", Object.assign({ ref: titleRef }, { children: jsxs(Title, Object.assign({ headingLevel: "h3", size: size }, { children: [jsx("span", Object.assign({ className: "pfext-quick-start-task-header__title" }, { children: title })), isActiveTask && subtitle && (jsxs("span", { children: [' ', jsx("span", Object.assign({ "data-test-id": "quick-start-task-subtitle", className: "pfext-quick-start-task-header__subtitle" }, { children: subtitle }))] })), tryAgain] })) })));
    let status = 'default';
    if (taskStatus === QuickStartTaskStatus.FAILED) {
        status = 'error';
    }
    else if (taskStatus === QuickStartTaskStatus.SUCCESS) {
        status = 'success';
    }
    return (jsx(WizardNavItem, Object.assign({ content: content, stepIndex: taskIndex, onClick: () => onTaskSelect(taskIndex - 1), component: "button", isCurrent: isActiveTask, status: status, className: "pfext-quick-start-task-header" }, { children: children })));
};

const QuickStartTaskHeaderList = ({ tasks, allTaskStatuses, onTaskSelect, }) => (tasks === null || tasks === void 0 ? void 0 : tasks.length) > 0 ? (jsx("ul", Object.assign({ className: "pf-v6-c-wizard pf-v6-c-wizard__nav-list" }, { children: tasks.map((task, index) => (jsx(QuickStartTaskHeader, { title: task.title, taskIndex: index + 1, size: "md", taskStatus: allTaskStatuses[index], onTaskSelect: onTaskSelect }, task.title))) }))) : null;

const QuickStartConclusion = ({ tasks, conclusion, allTaskStatuses, nextQuickStarts, onQuickStartChange, onTaskSelect, }) => {
    const hasFailedTask = allTaskStatuses.includes(QuickStartTaskStatus.FAILED);
    const { getResource } = useContext(QuickStartContext);
    return (jsxs(Fragment$1, { children: [jsx(QuickStartTaskHeaderList, { tasks: tasks, allTaskStatuses: allTaskStatuses, onTaskSelect: onTaskSelect }), jsx(QuickStartMarkdownView, { content: hasFailedTask
                    ? getResource('One or more verifications did not pass during this quick start. Revisit the tasks or the help links, and then try again.')
                    : conclusion }), !hasFailedTask &&
                nextQuickStarts &&
                nextQuickStarts.length > 0 &&
                nextQuickStarts.map((nextQuickStart, index) => {
                    var _a;
                    return (jsx(Button, Object.assign({ variant: "link", onClick: () => onQuickStartChange(nextQuickStart.metadata.name), isInline: true, icon: jsx(ArrowRightIcon, {}), iconPosition: "end", isBlock: true, style: { marginTop: 'var(--pf-t--global--spacer--md' } }, { children: getResource('Start {{nextQSDisplayName}} quick start').replace('{{nextQSDisplayName}}', (_a = nextQuickStart === null || nextQuickStart === void 0 ? void 0 : nextQuickStart.spec) === null || _a === void 0 ? void 0 : _a.displayName) }), index));
                })] }));
};

const QuickStartIntroduction = ({ tasks, introduction, allTaskStatuses, prerequisites, onTaskSelect, }) => {
    const { getResource } = useContext(QuickStartContext);
    const prereqs = prerequisites === null || prerequisites === void 0 ? void 0 : prerequisites.filter((p) => p);
    const [isPrereqsExpanded, setIsPrereqsExpanded] = useState(false);
    const prereqList = (prereqs === null || prereqs === void 0 ? void 0 : prereqs.length) > 0 && (jsx(ExpandableSection, Object.assign({ toggleText: getResource('View Prerequisites ({{totalPrereqs}})').replace('{{totalPrereqs}}', prereqs.length), onToggle: () => setIsPrereqsExpanded(!isPrereqsExpanded) }, { children: jsx(List, { children: prereqs.map((pr) => (jsx(ListItem, { children: jsx(QuickStartMarkdownView, { content: pr }) }, pr))) }) })));
    return (jsxs(Stack, Object.assign({ hasGutter: true }, { children: [jsx(QuickStartMarkdownView, { content: introduction }), prereqList, jsxs("p", { children: [getResource('In this quick start, you will complete {{count, number}} task', (tasks === null || tasks === void 0 ? void 0 : tasks.length) || 0).replace('{{count, number}}', (tasks === null || tasks === void 0 ? void 0 : tasks.length) || 0), ":"] }), jsx(QuickStartTaskHeaderList, { tasks: tasks, allTaskStatuses: allTaskStatuses, onTaskSelect: onTaskSelect })] })));
};

const getAlertVariant = (status) => {
    switch (status) {
        case QuickStartTaskStatus.SUCCESS:
            return 'success';
        case QuickStartTaskStatus.FAILED:
            return 'danger';
        default:
            return 'info';
    }
};
const QuickStartTaskReview = ({ review, taskStatus, onTaskReview, }) => {
    const { instructions, failedTaskHelp: taskHelp } = review;
    const { getResource } = useContext(QuickStartContext);
    return (jsxs(Alert, Object.assign({ variant: getAlertVariant(taskStatus), title: getResource('Check your work'), isInline: true, role: "alert", style: {
            marginBottom: 'var(--pf-t--global--spacer--md)',
        } }, { children: [jsx(QuickStartMarkdownView, { content: instructions }), jsxs("span", Object.assign({ className: "pfext-quick-start-task-review__actions" }, { children: [jsx(Radio, { id: "review-success", name: "review-success", "data-testid": "qs-drawer-check-yes", label: getResource('Yes'), className: "pfext-quick-start-task-review__radio", isChecked: taskStatus === QuickStartTaskStatus.SUCCESS, onChange: () => onTaskReview(QuickStartTaskStatus.SUCCESS) }), jsx(Radio, { id: "review-failed", name: "review-failed", "data-testid": "qs-drawer-check-no", label: getResource('No'), className: "pfext-quick-start-task-review__radio", isChecked: taskStatus === QuickStartTaskStatus.FAILED, onChange: () => onTaskReview(QuickStartTaskStatus.FAILED) })] })), taskStatus === QuickStartTaskStatus.FAILED && taskHelp && (jsx(QuickStartMarkdownView, { content: taskHelp, exactHeight: true }))] })));
};

const QuickStartTasks = ({ tasks, taskNumber, allTaskStatuses, onTaskReview, onTaskSelect, }) => {
    const { getResource, alwaysShowTaskReview } = useContext(QuickStartContext);
    return (jsx("div", Object.assign({ className: "pf-v6-c-wizard pf-v6-c-wizard__nav-list", style: { padding: '0 0 0 0' } }, { children: jsx("ul", { children: tasks
                .filter((_, index) => allTaskStatuses[index] !== QuickStartTaskStatus.INIT)
                .map((task, index) => {
                const { title, description, review } = task;
                const isActiveTask = index === taskNumber;
                const taskStatus = allTaskStatuses[index];
                const shouldShowTaskReview = (!QUICKSTART_TASKS_INITIAL_STATES.includes(taskStatus) || alwaysShowTaskReview) &&
                    review;
                return (jsx(Fragment, { children: jsx(QuickStartTaskHeader, Object.assign({ taskIndex: index + 1, title: title, size: "md", subtitle: getResource('{{index, number}} of {{tasks, number}}')
                            .replace('{{index, number}}', index + 1)
                            .replace('{{tasks, number}}', tasks.length), taskStatus: taskStatus, isActiveTask: isActiveTask, onTaskSelect: onTaskSelect }, { children: isActiveTask && (jsxs(Stack, Object.assign({ hasGutter: true }, { children: [jsx(QuickStartMarkdownView, { content: description }), shouldShowTaskReview && (jsx(QuickStartTaskReview, { review: review, taskStatus: taskStatus, onTaskReview: onTaskReview }))] }))) })) }, title));
            }) }) })));
};

const QuickStartContent = forwardRef(({ quickStart, nextQuickStarts = [], taskNumber, allTaskStatuses, onTaskSelect, onTaskReview, onQuickStartChange, }, ref) => {
    const { spec: { introduction, tasks, conclusion, prerequisites }, } = quickStart;
    const totalTasks = tasks === null || tasks === void 0 ? void 0 : tasks.length;
    return (jsxs("div", Object.assign({ className: "pfext-quick-start-task", ref: ref }, { children: [taskNumber === -1 && (jsx(QuickStartIntroduction, { tasks: tasks, allTaskStatuses: allTaskStatuses, introduction: introduction, prerequisites: prerequisites, onTaskSelect: onTaskSelect })), taskNumber > -1 && taskNumber < totalTasks && (jsx(QuickStartTasks, { tasks: tasks, taskNumber: taskNumber, allTaskStatuses: allTaskStatuses, onTaskReview: onTaskReview, onTaskSelect: onTaskSelect })), taskNumber === totalTasks && (jsx(QuickStartConclusion, { tasks: tasks, conclusion: conclusion, allTaskStatuses: allTaskStatuses, nextQuickStarts: nextQuickStarts, onQuickStartChange: onQuickStartChange, onTaskSelect: onTaskSelect }))] })));
});

const QuickStartFooter = ({ status, taskNumber, totalTasks, onNext, onBack, quickStartId, className, }) => {
    const { restartQuickStart, getResource } = useContext(QuickStartContext);
    const PrimaryButtonText = useMemo(() => ({
        START: getResource('Start'),
        CONTINUE: getResource('Continue'),
        NEXT: getResource('Next'),
        CLOSE: getResource('Close'),
    }), [getResource]);
    const SecondaryButtonText = useMemo(() => ({
        BACK: getResource('Back'),
        RESTART: getResource('Restart'),
    }), [getResource]);
    const onRestart = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        restartQuickStart(quickStartId, totalTasks);
    }, [quickStartId, restartQuickStart, totalTasks]);
    const getPrimaryButtonText = useMemo(() => {
        if (status === QuickStartStatus.NOT_STARTED) {
            return PrimaryButtonText.START;
        }
        if (taskNumber === totalTasks) {
            return PrimaryButtonText.CLOSE;
        }
        if (taskNumber > -1 && taskNumber < totalTasks) {
            return PrimaryButtonText.NEXT;
        }
        return PrimaryButtonText.CONTINUE;
    }, [taskNumber, totalTasks, PrimaryButtonText, status]);
    const getPrimaryButton = useMemo(() => (jsx(Button, Object.assign({ variant: "primary", className: "pfext-quick-start-footer__actionbtn", onClick: onNext, "data-testid": `qs-drawer-${camelize(getPrimaryButtonText)}`, "data-test": `${getPrimaryButtonText} button` }, { children: getPrimaryButtonText }))), [getPrimaryButtonText, onNext]);
    const getSecondaryButton = useMemo(() => taskNumber === -1 && status !== QuickStartStatus.NOT_STARTED ? (jsx(Button, Object.assign({ variant: "secondary", onClick: onRestart, "data-testid": "qs-drawer-restart" }, { children: SecondaryButtonText.RESTART }))) : (taskNumber > -1 && (jsx(Button, Object.assign({ variant: "secondary", onClick: onBack, "data-testid": "qs-drawer-back" }, { children: SecondaryButtonText.BACK })))), [onRestart, onBack, SecondaryButtonText, status, taskNumber]);
    const getSideNoteAction = useMemo(() => taskNumber !== -1 && (jsx(Button, Object.assign({ variant: "link", onClick: onRestart, "data-testid": "qs-drawer-side-note-action" }, { children: SecondaryButtonText.RESTART }))), [taskNumber, onRestart, SecondaryButtonText.RESTART]);
    return (jsx("div", Object.assign({ className: css('pfext-quick-start-footer', className) }, { children: jsxs(ActionList, { children: [jsxs(ActionListGroup, { children: [jsx(ActionListItem, { children: getPrimaryButton }), jsx(ActionListItem, { children: getSecondaryButton })] }), jsx(ActionListGroup, { children: jsx(ActionListItem, { children: getSideNoteAction }) })] }) })));
};

const QuickStartController = ({ quickStart, nextQuickStarts, contentRef, footerClass, }) => {
    const { metadata: { name }, spec: { tasks = [] }, } = quickStart;
    const totalTasks = tasks === null || tasks === void 0 ? void 0 : tasks.length;
    const { activeQuickStartID, allQuickStartStates, setAllQuickStartStates, activeQuickStartState, setActiveQuickStart, setQuickStartTaskNumber, setQuickStartTaskStatus, nextStep, previousStep, } = useContext(QuickStartContext);
    useEffect(() => {
        // If activeQuickStartID was changed through prop from QuickStartContainer, need to init the state if it does not exist yet
        if (activeQuickStartID && !allQuickStartStates[activeQuickStartID]) {
            setAllQuickStartStates(Object.assign(Object.assign({}, allQuickStartStates), { [activeQuickStartID]: getDefaultQuickStartState() }));
        }
    }, [activeQuickStartID, allQuickStartStates, setAllQuickStartStates]);
    const status = activeQuickStartState === null || activeQuickStartState === void 0 ? void 0 : activeQuickStartState.status;
    const taskNumber = activeQuickStartState === null || activeQuickStartState === void 0 ? void 0 : activeQuickStartState.taskNumber;
    const allTaskStatuses = tasks.map((task, index) => activeQuickStartState[`taskStatus${index}`]);
    const handleQuickStartChange = useCallback((quickStartId) => setActiveQuickStart(quickStartId), [setActiveQuickStart]);
    const handleTaskStatusChange = useCallback((newTaskStatus) => setQuickStartTaskStatus(newTaskStatus), [setQuickStartTaskStatus]);
    const getQuickStartActiveTask = useCallback(() => {
        let activeTaskNumber = 0;
        while (activeTaskNumber !== totalTasks &&
            activeQuickStartState[`taskStatus${activeTaskNumber}`] === QuickStartTaskStatus.SUCCESS) {
            activeTaskNumber++;
        }
        return activeTaskNumber;
    }, [totalTasks, activeQuickStartState]);
    const handleQuickStartContinue = useCallback(() => {
        const activeTaskNumber = getQuickStartActiveTask();
        setQuickStartTaskNumber(name, activeTaskNumber);
    }, [getQuickStartActiveTask, setQuickStartTaskNumber, name]);
    const handleNext = useCallback(() => {
        if (status === QuickStartStatus.COMPLETE && taskNumber === totalTasks) {
            return handleQuickStartChange('');
        }
        if (status !== QuickStartStatus.NOT_STARTED && taskNumber === -1) {
            return handleQuickStartContinue();
        }
        return nextStep(totalTasks);
    }, [handleQuickStartChange, nextStep, status, taskNumber, totalTasks, handleQuickStartContinue]);
    const handleBack = useCallback(() => previousStep(), [previousStep]);
    const handleTaskSelect = useCallback((selectedTaskNumber) => {
        setQuickStartTaskNumber(name, selectedTaskNumber);
    }, [name, setQuickStartTaskNumber]);
    return (jsxs(Fragment$1, { children: [jsx(QuickStartContent, { quickStart: quickStart, nextQuickStarts: nextQuickStarts, taskNumber: taskNumber, allTaskStatuses: allTaskStatuses, onTaskSelect: handleTaskSelect, onTaskReview: handleTaskStatusChange, onQuickStartChange: handleQuickStartChange, ref: contentRef }), jsx(QuickStartFooter, { status: status, taskNumber: taskNumber, totalTasks: totalTasks, onNext: handleNext, onBack: handleBack, className: footerClass, quickStartId: quickStart.metadata.name })] }));
};

const getElement = (appendTo) => {
    if (typeof appendTo === 'function') {
        return appendTo();
    }
    return appendTo;
};
const useScrollTopOnTaskNumberChange = (node, taskNumber) => {
    useEffect(() => {
        if (node) {
            node.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }, [taskNumber, node]);
};
const QuickStartPanelContent = (_a) => {
    var { quickStarts = [], handleClose, activeQuickStartID, appendTo, isResizable = true, showClose = true, footerClass } = _a, props = __rest(_a, ["quickStarts", "handleClose", "activeQuickStartID", "appendTo", "isResizable", "showClose", "footerClass"]);
    const titleRef = useRef(null);
    const { getResource, activeQuickStartState, focusOnQuickStart } = useContext(QuickStartContext);
    const [contentRef, setContentRef] = useState();
    const quickStart = quickStarts.find((qs) => qs.metadata.name === activeQuickStartID);
    const taskNumber = activeQuickStartState === null || activeQuickStartState === void 0 ? void 0 : activeQuickStartState.taskNumber;
    useScrollTopOnTaskNumberChange(contentRef, taskNumber);
    const nextQuickStarts = quickStarts.filter((qs) => { var _a; return (_a = quickStart === null || quickStart === void 0 ? void 0 : quickStart.spec.nextQuickStart) === null || _a === void 0 ? void 0 : _a.includes(qs.metadata.name); });
    const getStep = () => {
        var _a;
        const tasks = ((_a = quickStart.spec.tasks) === null || _a === void 0 ? void 0 : _a.length) || 0;
        if (Number.parseInt(taskNumber) === -1) {
            return 'intro';
        }
        if (Number.parseInt(taskNumber) === tasks) {
            return 'conclusion';
        }
        return Number.parseInt(taskNumber) + 1;
    };
    useEffect(() => {
        if (focusOnQuickStart && quickStart) {
            titleRef.current.focus();
        }
    }, [focusOnQuickStart, quickStart]);
    const content = quickStart ? (jsxs(DrawerPanelContent, Object.assign({ isResizable: isResizable, "data-testid": `qs-drawer-${camelize(quickStart.spec.displayName)}`, "data-qs": `qs-step-${getStep()}`, "data-test": "quickstart drawer", style: { '--pf-v6-c-drawer__panel--PaddingBlockStart': '0' } }, props, { children: [jsx("div", Object.assign({ className: "pfext-quick-start-panel-content" }, { children: jsxs(DrawerHead, { children: [jsxs("div", Object.assign({ tabIndex: -1, ref: titleRef }, { children: [jsxs(Title, Object.assign({ headingLevel: "h2", size: "xl", style: { marginRight: 'var(--pf-t--global--spacer--md)' } }, { children: [jsx("span", { children: quickStart === null || quickStart === void 0 ? void 0 : quickStart.spec.displayName }), ' '] })), jsx("span", { children: (quickStart === null || quickStart === void 0 ? void 0 : quickStart.spec.durationMinutes)
                                        ? getResource('{{type}} • {{duration, number}} minutes', quickStart === null || quickStart === void 0 ? void 0 : quickStart.spec.durationMinutes)
                                            .replace('{{duration, number}}', quickStart === null || quickStart === void 0 ? void 0 : quickStart.spec.durationMinutes)
                                            .replace('{{type}}', getResource('Type'))
                                        : getResource('Type') })] })), showClose && (jsx(DrawerActions, { children: jsx(DrawerCloseButton, { onClick: handleClose, className: "pfext-quick-start-panel-content__close-button", "data-testid": "qs-drawer-close" }) }))] }) })), jsx(DrawerPanelBody, Object.assign({ className: "pfext-quick-start-panel-content__body", "data-test": "content" }, { children: jsx(QuickStartController, { quickStart: quickStart, nextQuickStarts: nextQuickStarts, footerClass: footerClass, contentRef: setContentRef }) }))] }))) : null;
    if (appendTo) {
        return ReactDOM.createPortal(content, getElement(appendTo));
    }
    return content;
};

const QuickStartDrawerContent = (_a) => {
    var { quickStarts = [], appendTo, fullWidth, handleDrawerClose } = _a, props = __rest(_a, ["quickStarts", "appendTo", "fullWidth", "handleDrawerClose"]);
    const { activeQuickStartID, allQuickStarts = [], activeQuickStartState, } = useContext(QuickStartContext);
    const combinedQuickStarts = [...allQuickStarts, ...quickStarts].filter((qs, idx, arr) => arr.findIndex((q) => q.metadata.name === qs.metadata.name) === idx);
    const handleClose = () => {
        handleDrawerClose && handleDrawerClose(activeQuickStartState === null || activeQuickStartState === void 0 ? void 0 : activeQuickStartState.status);
    };
    const fullWidthPanelStyle = fullWidth
        ? {
            style: {
                flex: 1,
            },
        }
        : {};
    return (jsx(QuickStartPanelContent, Object.assign({ quickStarts: combinedQuickStarts, handleClose: handleClose, activeQuickStartID: activeQuickStartID, appendTo: appendTo, isResizable: !fullWidth }, fullWidthPanelStyle, props)));
};

const QuickStartDrawer = (_a) => {
    var { quickStarts = [], children, appendTo, fullWidth, onCloseInProgress, onCloseNotInProgress } = _a, props = __rest(_a, ["quickStarts", "children", "appendTo", "fullWidth", "onCloseInProgress", "onCloseNotInProgress"]);
    const { activeQuickStartID, setActiveQuickStart, allQuickStarts = [], allQuickStartStates, setAllQuickStartStates, } = useContext(QuickStartContext);
    const combinedQuickStarts = allQuickStarts.concat(quickStarts);
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        // if there is a quick start param, but the quick start is not active, set it
        // this can happen if a new browser session is opened or an incognito window for example
        const quickStartIdFromParam = params.get(QUICKSTART_ID_FILTER_KEY) || '';
        if (quickStartIdFromParam && activeQuickStartID !== quickStartIdFromParam) {
            const activeQuickStart = getQuickStartByName(quickStartIdFromParam, combinedQuickStarts);
            // don't try to load a quick start that is actually just an external resource (spec.link)
            if (combinedQuickStarts.length > 0 && activeQuickStart && !activeQuickStart.spec.link) {
                setActiveQuickStart(quickStartIdFromParam);
            }
        }
    }, [activeQuickStartID, combinedQuickStarts, setActiveQuickStart]);
    useEffect(() => {
        // If activeQuickStartID was changed through prop from QuickStartContainer, need to init the state if it does not exist yet
        if (activeQuickStartID && !allQuickStartStates[activeQuickStartID]) {
            setAllQuickStartStates(Object.assign(Object.assign({}, allQuickStartStates), { [activeQuickStartID]: getDefaultQuickStartState() }));
        }
    }, [activeQuickStartID, allQuickStartStates, setAllQuickStartStates]);
    const [modalOpen, setModalOpen] = useState(false);
    const onClose = () => setActiveQuickStart('');
    const handleClose = (activeQuickStartStatus) => {
        if (activeQuickStartStatus === QuickStartStatus.IN_PROGRESS) {
            if (onCloseInProgress) {
                onCloseInProgress();
            }
            else {
                setModalOpen(true);
            }
        }
        else if (onCloseNotInProgress) {
            onCloseNotInProgress();
        }
        else {
            onClose();
        }
    };
    const onModalConfirm = () => {
        setModalOpen(false);
        onClose();
    };
    const onModalCancel = () => setModalOpen(false);
    const fullWidthBodyStyle = fullWidth
        ? {
            style: {
                display: activeQuickStartID ? 'none' : 'flex',
            },
        }
        : {};
    return (jsxs(Fragment$1, { children: [jsx(Drawer, Object.assign({ isExpanded: !!activeQuickStartID, isInline: true }, props, { children: jsx(DrawerContent, Object.assign({ panelContent: jsx(QuickStartDrawerContent, { quickStarts: combinedQuickStarts, handleDrawerClose: handleClose, appendTo: appendTo, fullWidth: fullWidth }) }, fullWidthBodyStyle, { children: jsx(DrawerContentBody, { children: children }) })) })), jsx(QuickStartCloseModal, { isOpen: modalOpen, onConfirm: onModalConfirm, onCancel: onModalCancel })] }));
};

const QuickStartContainer = (_a) => {
    var { quickStarts, children, activeQuickStartID, allQuickStartStates, setActiveQuickStartID, setAllQuickStartStates, appendTo, fullWidth, onCloseInProgress, onCloseNotInProgress, resourceBundle, showCardFooters, useLegacyHeaderColors, language, loading = false, useQueryParams = true, markdown, contextProps, alwaysShowTaskReview = true, isManagedDrawer = true } = _a, props = __rest(_a, ["quickStarts", "children", "activeQuickStartID", "allQuickStartStates", "setActiveQuickStartID", "setAllQuickStartStates", "appendTo", "fullWidth", "onCloseInProgress", "onCloseNotInProgress", "resourceBundle", "showCardFooters", "useLegacyHeaderColors", "language", "loading", "useQueryParams", "markdown", "contextProps", "alwaysShowTaskReview", "isManagedDrawer"]);
    const valuesForQuickstartContext = useValuesForQuickStartContext(Object.assign({ allQuickStarts: quickStarts, activeQuickStartID,
        setActiveQuickStartID,
        allQuickStartStates,
        setAllQuickStartStates, footer: {
            show: showCardFooters,
        }, useLegacyHeaderColors,
        language, resourceBundle: Object.assign({}, resourceBundle), loading,
        useQueryParams,
        markdown,
        alwaysShowTaskReview }, contextProps));
    useEffect(() => {
        if (quickStarts &&
            JSON.stringify(quickStarts) !== JSON.stringify(valuesForQuickstartContext.allQuickStarts)) {
            valuesForQuickstartContext.setAllQuickStarts(quickStarts);
        }
    }, [quickStarts, valuesForQuickstartContext]);
    useEffect(() => {
        if (loading !== valuesForQuickstartContext.loading) {
            valuesForQuickstartContext.setLoading(loading);
        }
    }, [loading, valuesForQuickstartContext]);
    const drawerProps = Object.assign({ appendTo,
        fullWidth,
        onCloseInProgress,
        onCloseNotInProgress }, props);
    return (jsx(QuickStartContext.Provider, Object.assign({ value: valuesForQuickstartContext }, { children: isManagedDrawer ? (jsx(QuickStartDrawer, Object.assign({}, drawerProps, { children: children }))) : (children) })));
};

const HelpTopicContextDefaults = {
    helpTopics: [],
    setHelpTopics: () => { },
    activeHelpTopic: null,
    setActiveHelpTopicByName: () => { },
    filteredHelpTopics: [],
    setFilteredHelpTopics: () => { },
    loading: false,
};
const HelpTopicContext = createContext(HelpTopicContextDefaults);
const useValuesForHelpTopicContext = (value = {}) => {
    const combinedValue = Object.assign(Object.assign({}, HelpTopicContextDefaults), value);
    const [loading, setLoading] = useState(combinedValue.loading);
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const [helpTopics, setHelpTopics] = useState(combinedValue.helpTopics || []);
    const [activeHelpTopic, setActiveHelpTopic] = useState(combinedValue.activeHelpTopic || null);
    const setActiveHelpTopicByName = useCallback((helpTopicName) => {
        const topic = helpTopics.find((t) => t.name === helpTopicName);
        if (!helpTopicName) {
            setActiveHelpTopic(null);
            return;
        }
        setActiveHelpTopic(topic);
    }, [helpTopics]);
    const [filteredHelpTopics, setFilteredHelpTopics] = useState(combinedValue.filteredHelpTopics || []);
    return {
        helpTopics,
        setHelpTopics,
        activeHelpTopic,
        setActiveHelpTopicByName,
        filteredHelpTopics,
        setFilteredHelpTopics,
        loading,
        setLoading,
    };
};

const HelpTopicPanelContent = (_a) => {
    var _b, _c;
    var { activeHelpTopic = null, filteredHelpTopics = [], isResizable = true, onClose } = _a, props = __rest(_a, ["activeHelpTopic", "filteredHelpTopics", "isResizable", "onClose"]);
    const { setActiveHelpTopicByName } = useContext(HelpTopicContext);
    const [isHelpTopicMenuOpen, setIsHelpTopicMenuOpen] = useState(false);
    const toggleHelpTopicMenu = () => {
        setIsHelpTopicMenuOpen(!isHelpTopicMenuOpen);
    };
    const onSelectHelpTopic = (_event, value) => {
        const topicName = value;
        setActiveHelpTopicByName(topicName.toString());
        toggleHelpTopicMenu();
    };
    const helpTopicOptions = filteredHelpTopics.length > 1 &&
        filteredHelpTopics.map((topic) => (jsx(SelectOption, Object.assign({ value: topic.name }, { children: topic.title }), topic.name)));
    const paddingContainer = (children) => jsx("div", Object.assign({ style: { padding: '24px' } }, { children: children }));
    const panelBodyItems = (jsxs(Fragment$1, { children: [paddingContainer(jsx(QuickStartMarkdownView, { content: activeHelpTopic === null || activeHelpTopic === void 0 ? void 0 : activeHelpTopic.content })), !!((_b = activeHelpTopic === null || activeHelpTopic === void 0 ? void 0 : activeHelpTopic.links) === null || _b === void 0 ? void 0 : _b.length) && jsx(Divider, {}), paddingContainer(jsx(Stack, Object.assign({ hasGutter: true }, { children: (_c = activeHelpTopic === null || activeHelpTopic === void 0 ? void 0 : activeHelpTopic.links) === null || _c === void 0 ? void 0 : _c.map(({ href, text, newTab, isExternal }, index) => (jsx(StackItem, { children: jsx(Button, Object.assign({ component: "a", href: href, target: newTab ? '_blank' : '', rel: "noopener noreferrer", variant: "link", "aria-label": `Open documentation in new window`, isInline: true, icon: isExternal ? jsx(ExternalLinkAltIcon, {}) : null, iconPosition: "right", style: { fontSize: 'inherit' } }, { children: text || href })) }, index))) })))] }));
    const content = (jsx(DrawerPanelContent, Object.assign({ isResizable: isResizable }, props, { children: jsxs("div", { children: [jsxs(DrawerHead, { children: [jsxs("div", { children: [helpTopicOptions && (jsx(Select, Object.assign({ isPlain: true, id: "help-topics-select", selected: activeHelpTopic, isOpen: isHelpTopicMenuOpen, onSelect: onSelectHelpTopic, onOpenChange: (isOpen) => setIsHelpTopicMenuOpen(isOpen), toggle: (toggleRef) => (jsx(MenuToggle, Object.assign({ isFullWidth: true, ref: toggleRef, icon: jsx(BarsIcon, {}), onClick: toggleHelpTopicMenu, isExpanded: isHelpTopicMenuOpen }, { children: activeHelpTopic === null || activeHelpTopic === void 0 ? void 0 : activeHelpTopic.title }))) }, { children: jsx(SelectList, { children: helpTopicOptions }) }))), jsx(Title, Object.assign({ headingLevel: "h1", size: "xl", style: { marginRight: 'var(--pf-t--global--spacer--md)' } }, { children: activeHelpTopic === null || activeHelpTopic === void 0 ? void 0 : activeHelpTopic.title }))] }), jsx(DrawerActions, { children: jsx(DrawerCloseButton, { onClick: onClose, "data-testid": "qs-drawer-close" }) })] }), jsx(Divider, {}), jsx(DrawerPanelBody, Object.assign({ "data-test": "content" }, { children: panelBodyItems }))] }) })));
    return content;
};

const HelpTopicContainer = (_a) => {
    var { helpTopics, children, resourceBundle, language, loading = false, markdown, contextProps } = _a, props = __rest(_a, ["helpTopics", "children", "resourceBundle", "language", "loading", "markdown", "contextProps"]);
    const valuesForHelpTopicContext = useValuesForHelpTopicContext(Object.assign({ helpTopics,
        language, resourceBundle: Object.assign({}, resourceBundle), loading,
        markdown }, contextProps));
    useEffect(() => {
        if (loading !== valuesForHelpTopicContext.loading) {
            valuesForHelpTopicContext.setLoading(loading);
        }
    }, [loading, valuesForHelpTopicContext]);
    useEffect(() => {
        if (helpTopics &&
            JSON.stringify(helpTopics) !== JSON.stringify(valuesForHelpTopicContext.helpTopics)) {
            valuesForHelpTopicContext.setHelpTopics(helpTopics);
        }
    }, [helpTopics, valuesForHelpTopicContext]);
    return (jsx(HelpTopicContext.Provider, Object.assign({ value: valuesForHelpTopicContext }, { children: jsx(HelpTopicDrawer, Object.assign({}, props, { children: children })) })));
};
const HelpTopicDrawer = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    const { activeHelpTopic, filteredHelpTopics, setActiveHelpTopicByName } = useContext(HelpTopicContext);
    const onClose = () => {
        setActiveHelpTopicByName('');
    };
    const panelContent = (jsx(HelpTopicPanelContent, { activeHelpTopic: activeHelpTopic, filteredHelpTopics: filteredHelpTopics, onClose: onClose }));
    return (jsx(Fragment$1, { children: jsx(Drawer, Object.assign({ isExpanded: !!activeHelpTopic, isInline: true }, props, { children: children ? (jsx(DrawerContent, Object.assign({ panelContent: panelContent }, { children: jsx(DrawerContentBody, { children: children }) }))) : (jsx("div", Object.assign({ className: "pf-v6-c-drawer__main" }, { children: panelContent }))) })) }));
};

const useLocalStorage = (key, initialValue) => {
    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    const [storedValue, setStoredValue] = useState(() => {
        try {
            // Get from local storage by key
            const item = window.localStorage.getItem(key);
            // Parse stored json or if none return initialValue
            return item ? JSON.parse(item) : initialValue;
        }
        catch (error) {
            // If error also return initialValue
            // eslint-disable-next-line no-console
            console.log(error);
            return initialValue;
        }
    });
    // Return a wrapped version of useState's setter function that ...
    // ... persists the new value to localStorage.
    const setValue = (value) => {
        try {
            // Allow value to be a function so we have same API as useState
            const valueToStore = value instanceof Function ? value(storedValue) : value;
            // Save state
            setStoredValue(valueToStore);
            // Save to local storage
            window.localStorage.setItem(key, JSON.stringify(valueToStore));
        }
        catch (error) {
            // A more advanced implementation would handle the error case
            // eslint-disable-next-line no-console
            console.log(error);
        }
    };
    return [storedValue, setValue];
};

/* eslint-disable */
// Brought in from dev to publish this with QS module
// Dev now imports from here
const ProcQuickStartParser = (quickStart, environmentVariables) => {
    var _a;
    const replaceEnvironmentVariables = (s) => s === null || s === void 0 ? void 0 : s.replace(/\${(\w+)}/, (substring, name) => {
        return environmentVariables ? ([name] ? environmentVariables[name] : substring) : substring;
    });
    quickStart.spec.tasks = (_a = quickStart.spec.tasks) === null || _a === void 0 ? void 0 : _a.map((task, index) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        let proc;
        let answer;
        if (typeof task === 'string') {
            proc = task;
            answer = {};
        }
        else {
            proc = task.proc;
            answer = task;
            delete task.proc;
        }
        let description = '', procedure, verification, title, summaryFailed, success, reviewFailed, prerequisites;
        if (proc) {
            const taskDOM = document.createElement('div');
            taskDOM.innerHTML = proc;
            // remove the screencapture images
            taskDOM.querySelectorAll('.imageblock.screencapture').forEach((node) => {
                var _a;
                (_a = node.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(node);
            });
            title = (_a = taskDOM
                .querySelector('h1:first-child,h2:first-child,h3:first-child,h4:first-child,h5:first-child')) === null || _a === void 0 ? void 0 : _a.innerHTML.trim();
            let sectionBody = taskDOM.querySelector('.sectionbody');
            if (!(sectionBody === null || sectionBody === void 0 ? void 0 : sectionBody.hasChildNodes())) {
                // possibly in other templates, where we want to look for article
                sectionBody = taskDOM.querySelector('article');
            }
            if (sectionBody) {
                for (let i = 0; i < sectionBody.children.length || 0; i++) {
                    /**
                    child typically looks like:
          
                    <div class="paragraph|olist|ulist|admonitionblock">
                       <div class="title">Procedure|Prerequisites|Verification|Note|Warning</div>
                       <ol|ul class="arabic">
                         <li>
                         <li>...
                       </ol|ul>
                    </div>
          
                    And the below code extracts the <ol> or <ul>
                    Except for when there is no <div class="title|heading"/>, then the description is extracted
                    in the else if below
                    */
                    const child = sectionBody.children.item(i);
                    // find the title
                    const sectionTitle = child === null || child === void 0 ? void 0 : child.querySelector('.heading,.title');
                    // should this section be assigned to a specific section
                    const sectionTitleText = (_b = sectionTitle === null || sectionTitle === void 0 ? void 0 : sectionTitle.textContent) === null || _b === void 0 ? void 0 : _b.trim();
                    const isKnownSection = ['Procedure', 'Verification', 'Prerequisites'].includes((_c = sectionTitle === null || sectionTitle === void 0 ? void 0 : sectionTitle.textContent) === null || _c === void 0 ? void 0 : _c.trim());
                    if (isKnownSection) {
                        switch (sectionTitleText) {
                            case 'Procedure':
                                procedure = (_d = child === null || child === void 0 ? void 0 : child.querySelector(':not(.heading):not(.title)')) === null || _d === void 0 ? void 0 : _d.outerHTML.trim();
                                break;
                            case 'Verification':
                                verification = (_e = child === null || child === void 0 ? void 0 : child.querySelector(':not(.heading):not(.title)')) === null || _e === void 0 ? void 0 : _e.outerHTML.trim();
                                break;
                            case 'Prerequisites':
                                prerequisites = (_f = child === null || child === void 0 ? void 0 : child.querySelector(':not(.heading):not(.title)')) === null || _f === void 0 ? void 0 : _f.outerHTML.trim();
                                break;
                        }
                    }
                    else if (!procedure) {
                        // Otherwise if it comes before a procedure it's part of the description
                        description = description + (child === null || child === void 0 ? void 0 : child.outerHTML.trim());
                    }
                }
            }
            success = (_g = taskDOM.querySelector('.qs-summary.success')) === null || _g === void 0 ? void 0 : _g.innerHTML.trim();
            reviewFailed = (_h = taskDOM.querySelector('.qs-review.failed')) === null || _h === void 0 ? void 0 : _h.innerHTML.trim();
            summaryFailed = (_j = taskDOM.querySelector('.qs-summary.failed')) === null || _j === void 0 ? void 0 : _j.innerHTML.trim();
        }
        answer.title = replaceEnvironmentVariables(answer.title || title);
        answer.description = replaceEnvironmentVariables(answer.description || `${description} ${prerequisites || ''} ${procedure}`);
        answer.review = answer.review || {};
        answer.review.instructions = replaceEnvironmentVariables(((_k = answer.review) === null || _k === void 0 ? void 0 : _k.instructions) || verification || 'Have you completed these steps?');
        answer.review.failedTaskHelp = replaceEnvironmentVariables(answer.review.failedTaskHelp ||
            reviewFailed ||
            'This task isn’t verified yet. Try the task again.');
        answer.summary = answer.summary || {};
        answer.summary.success = replaceEnvironmentVariables(answer.summary.success || success || 'You have completed this task!');
        answer.summary.failed = replaceEnvironmentVariables(answer.summary.failed || summaryFailed || 'Try the steps again.');
        return answer;
    });
    return quickStart;
};

export { Box, CamelCaseWrap, EmptyBox, HELP_TOPIC_NAME_KEY, HelpTopicContainer, HelpTopicContext, HelpTopicContextDefaults, HelpTopicDrawer, Loading, LoadingBox, ProcQuickStartParser, QUICKSTART_ID_FILTER_KEY, QUICKSTART_SEARCH_FILTER_KEY, QUICKSTART_STATUS_FILTER_KEY, QUICKSTART_TASKS_INITIAL_STATES, QUICK_START_NAME, QuickStartCatalog, QuickStartCatalogEmptyState, QuickStartCatalogFilter, QuickStartCatalogFilterCount, QuickStartCatalogFilterCountWrapper, QuickStartCatalogFilterSearch, QuickStartCatalogFilterSearchWrapper, QuickStartCatalogFilterSelect, QuickStartCatalogFilterStatusWrapper, QuickStartCatalogHeader, QuickStartCatalogPage, QuickStartCatalogSection, QuickStartCatalogToolbar, QuickStartCloseModal, QuickStartContainer, QuickStartContext, QuickStartContextDefaults, QuickStartContextProvider, QuickStartController, QuickStartDrawer, QuickStartDrawerContent, QuickStartPanelContent, QuickStartStatus, QuickStartTaskStatus, QuickStartTile, QuickStartTileDescription, QuickStartTileFooter, QuickStartTileFooterExternal, QuickStartTileHeader, camelize, clearFilterParams, equalsIgnoreOrder, filterQuickStarts, getDefaultQuickStartState, getDisabledQuickStarts, getQuickStartByName, getQuickStartStatus, getQuickStartStatusCount, getResource, getTaskStatusKey, history, isDisabledQuickStart, removeQueryArgument, setQueryArgument, useLocalStorage, useValuesForHelpTopicContext, useValuesForQuickStartContext };
//# sourceMappingURL=index.es.js.map
